(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["mbc-core"] = factory();
	else
		root["mbc-core"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 160);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(72)))

/***/ }),
/* 1 */
/***/ (function(module, exports) {

var FunctionPrototype = Function.prototype;
var bind = FunctionPrototype.bind;
var call = FunctionPrototype.call;
var callBind = bind && bind.bind(call);

module.exports = bind ? function (fn) {
  return fn && callBind(call, fn);
} : function (fn) {
  return fn && function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = function (argument) {
  return typeof argument == 'function';
};


/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var shared = __webpack_require__(35);
var hasOwn = __webpack_require__(6);
var uid = __webpack_require__(47);
var NATIVE_SYMBOL = __webpack_require__(46);
var USE_SYMBOL_AS_UID = __webpack_require__(52);

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var symbolFor = Symbol && Symbol['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL && hasOwn(Symbol, name)) {
      WellKnownSymbolsStore[name] = Symbol[name];
    } else if (USE_SYMBOL_AS_UID && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__(2);

module.exports = function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1);
var toObject = __webpack_require__(16);

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(3);

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var isObject = __webpack_require__(5);

var String = global.String;
var TypeError = global.TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw TypeError(String(argument) + ' is not an object');
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var DESCRIPTORS = __webpack_require__(7);
var IE8_DOM_DEFINE = __webpack_require__(53);
var anObject = __webpack_require__(8);
var toPropertyKey = __webpack_require__(22);

var TypeError = global.TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(33);
var requireObjectCoercible = __webpack_require__(21);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var getOwnPropertyDescriptor = __webpack_require__(41).f;
var createNonEnumerableProperty = __webpack_require__(13);
var redefine = __webpack_require__(18);
var setGlobal = __webpack_require__(25);
var copyConstructorProperties = __webpack_require__(70);
var isForced = __webpack_require__(69);

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
  options.name        - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),
/* 12 */
/***/ (function(module, exports) {

var call = Function.prototype.call;

module.exports = call.bind ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(7);
var definePropertyModule = __webpack_require__(9);
var createPropertyDescriptor = __webpack_require__(20);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var isCallable = __webpack_require__(2);

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var toLength = __webpack_require__(61);

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var requireObjectCoercible = __webpack_require__(21);

var Object = global.Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1);

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var isCallable = __webpack_require__(2);
var hasOwn = __webpack_require__(6);
var createNonEnumerableProperty = __webpack_require__(13);
var setGlobal = __webpack_require__(25);
var inspectSource = __webpack_require__(26);
var InternalStateModule = __webpack_require__(44);
var CONFIGURABLE_FUNCTION_NAME = __webpack_require__(42).CONFIGURABLE;

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var name = options && options.name !== undefined ? options.name : key;
  var state;
  if (isCallable(value)) {
    if (String(name).slice(0, 7) === 'Symbol(') {
      name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
    }
    if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
      createNonEnumerableProperty(value, 'name', name);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
    }
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
});


/***/ }),
/* 19 */
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- safe
  return number !== number || number === 0 ? 0 : (number > 0 ? floor : ceil)(number);
};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);

var TypeError = global.TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var toPrimitive = __webpack_require__(71);
var isSymbol = __webpack_require__(43);

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var userAgent = __webpack_require__(59);

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var setGlobal = __webpack_require__(25);

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1);
var isCallable = __webpack_require__(2);
var store = __webpack_require__(24);

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(4);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(3);
var wellKnownSymbol = __webpack_require__(4);
var V8_VERSION = __webpack_require__(23);

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var classof = __webpack_require__(32);

var String = global.String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return String(argument);
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(17);

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) == 'Array';
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var TO_STRING_TAG_SUPPORT = __webpack_require__(28);
var isCallable = __webpack_require__(2);
var classofRaw = __webpack_require__(17);
var wellKnownSymbol = __webpack_require__(4);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var Object = global.Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var uncurryThis = __webpack_require__(1);
var fails = __webpack_require__(3);
var classof = __webpack_require__(17);

var Object = global.Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split(it, '') : Object(it);
} : Object;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__(19);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__(55);
var store = __webpack_require__(24);

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.19.3',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var isObject = __webpack_require__(5);

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),
/* 37 */
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPropertyKey = __webpack_require__(22);
var definePropertyModule = __webpack_require__(9);
var createPropertyDescriptor = __webpack_require__(20);

module.exports = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),
/* 39 */,
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(11);
var global = __webpack_require__(0);
var fails = __webpack_require__(3);
var isArray = __webpack_require__(31);
var isObject = __webpack_require__(5);
var toObject = __webpack_require__(16);
var lengthOfArrayLike = __webpack_require__(15);
var createProperty = __webpack_require__(38);
var arraySpeciesCreate = __webpack_require__(48);
var arrayMethodHasSpeciesSupport = __webpack_require__(29);
var wellKnownSymbol = __webpack_require__(4);
var V8_VERSION = __webpack_require__(23);

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';
var TypeError = global.TypeError;

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = lengthOfArrayLike(E);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(7);
var call = __webpack_require__(12);
var propertyIsEnumerableModule = __webpack_require__(67);
var createPropertyDescriptor = __webpack_require__(20);
var toIndexedObject = __webpack_require__(10);
var toPropertyKey = __webpack_require__(22);
var hasOwn = __webpack_require__(6);
var IE8_DOM_DEFINE = __webpack_require__(53);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(7);
var hasOwn = __webpack_require__(6);

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var getBuiltIn = __webpack_require__(14);
var isCallable = __webpack_require__(2);
var isPrototypeOf = __webpack_require__(54);
var USE_SYMBOL_AS_UID = __webpack_require__(52);

var Object = global.Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, Object(it));
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__(74);
var global = __webpack_require__(0);
var uncurryThis = __webpack_require__(1);
var isObject = __webpack_require__(5);
var createNonEnumerableProperty = __webpack_require__(13);
var hasOwn = __webpack_require__(6);
var shared = __webpack_require__(24);
var sharedKey = __webpack_require__(45);
var hiddenKeys = __webpack_require__(27);

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = uncurryThis(store.get);
  var wmhas = uncurryThis(store.has);
  var wmset = uncurryThis(store.set);
  set = function (it, metadata) {
    if (wmhas(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget(store, it) || {};
  };
  has = function (it) {
    return wmhas(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(35);
var uid = __webpack_require__(47);

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__(23);
var fails = __webpack_require__(3);

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1);

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var arraySpeciesConstructor = __webpack_require__(77);

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__(28);
var redefine = __webpack_require__(18);
var toString = __webpack_require__(80);

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  redefine(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var isCallable = __webpack_require__(2);
var tryToString = __webpack_require__(64);

var TypeError = global.TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1);
var fails = __webpack_require__(3);
var isCallable = __webpack_require__(2);
var classof = __webpack_require__(32);
var getBuiltIn = __webpack_require__(14);
var inspectSource = __webpack_require__(26);

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function (argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function (argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
    // we can't check .prototype since constructors produced by .bind haven't it
  } return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
};

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__(46);

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(7);
var fails = __webpack_require__(3);
var createElement = __webpack_require__(36);

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1);

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1);
var hasOwn = __webpack_require__(6);
var toIndexedObject = __webpack_require__(10);
var indexOf = __webpack_require__(76).indexOf;
var hiddenKeys = __webpack_require__(27);

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__(83);
var uncurryThis = __webpack_require__(1);
var IndexedObject = __webpack_require__(33);
var toObject = __webpack_require__(16);
var lengthOfArrayLike = __webpack_require__(15);
var arraySpeciesCreate = __webpack_require__(48);

var push = uncurryThis([].push);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that);
    var length = lengthOfArrayLike(self);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push(target, value);      // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push(target, value);      // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(3);

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
    method.call(null, argument || function () { throw 1; }, 1);
  });
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(14);

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var aCallable = __webpack_require__(50);

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable(func);
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__(19);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(56);
var enumBugKeys = __webpack_require__(37);

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

/* global ActiveXObject -- old IE, WSH */
var anObject = __webpack_require__(8);
var defineProperties = __webpack_require__(90);
var enumBugKeys = __webpack_require__(37);
var hiddenKeys = __webpack_require__(27);
var html = __webpack_require__(91);
var documentCreateElement = __webpack_require__(36);
var sharedKey = __webpack_require__(45);

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);

var String = global.String;

module.exports = function (argument) {
  try {
    return String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var DOMIterables = __webpack_require__(78);
var DOMTokenListPrototype = __webpack_require__(79);
var forEach = __webpack_require__(86);
var createNonEnumerableProperty = __webpack_require__(13);

var handlePrototype = function (CollectionPrototype) {
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  if (DOMIterables[COLLECTION_NAME]) {
    handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype);
  }
}

handlePrototype(DOMTokenListPrototype);


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call = __webpack_require__(12);
var uncurryThis = __webpack_require__(1);
var toString = __webpack_require__(30);
var regexpFlags = __webpack_require__(87);
var stickyHelpers = __webpack_require__(92);
var shared = __webpack_require__(35);
var create = __webpack_require__(63);
var getInternalState = __webpack_require__(44).get;
var UNSUPPORTED_DOT_ALL = __webpack_require__(102);
var UNSUPPORTED_NCG = __webpack_require__(103);

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt = uncurryThis(''.charAt);
var indexOf = uncurryThis(''.indexOf);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call(nativeExec, re1, 'a');
  call(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = call(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice(match.input, charsAdded);
        match[0] = stringSlice(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      call(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),
/* 68 */
/***/ (function(module, exports) {

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(3);
var isCallable = __webpack_require__(2);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var hasOwn = __webpack_require__(6);
var ownKeys = __webpack_require__(75);
var getOwnPropertyDescriptorModule = __webpack_require__(41);
var definePropertyModule = __webpack_require__(9);

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var call = __webpack_require__(12);
var isObject = __webpack_require__(5);
var isSymbol = __webpack_require__(43);
var getMethod = __webpack_require__(60);
var ordinaryToPrimitive = __webpack_require__(73);
var wellKnownSymbol = __webpack_require__(4);

var TypeError = global.TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),
/* 72 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var call = __webpack_require__(12);
var isCallable = __webpack_require__(2);
var isObject = __webpack_require__(5);

var TypeError = global.TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var isCallable = __webpack_require__(2);
var inspectSource = __webpack_require__(26);

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(inspectSource(WeakMap));


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(14);
var uncurryThis = __webpack_require__(1);
var getOwnPropertyNamesModule = __webpack_require__(62);
var getOwnPropertySymbolsModule = __webpack_require__(68);
var anObject = __webpack_require__(8);

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__(10);
var toAbsoluteIndex = __webpack_require__(34);
var lengthOfArrayLike = __webpack_require__(15);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var isArray = __webpack_require__(31);
var isConstructor = __webpack_require__(51);
var isObject = __webpack_require__(5);
var wellKnownSymbol = __webpack_require__(4);

var SPECIES = wellKnownSymbol('species');
var Array = global.Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 78 */
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = __webpack_require__(36);

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(28);
var classof = __webpack_require__(32);

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(7);
var FUNCTION_NAME_EXISTS = __webpack_require__(42).EXISTS;
var uncurryThis = __webpack_require__(1);
var defineProperty = __webpack_require__(9).f;

var FunctionPrototype = Function.prototype;
var functionToString = uncurryThis(FunctionPrototype.toString);
var nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var regExpExec = uncurryThis(nameRE.exec);
var NAME = 'name';

// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !FUNCTION_NAME_EXISTS) {
  defineProperty(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return regExpExec(nameRE, functionToString(this))[1];
      } catch (error) {
        return '';
      }
    }
  });
}


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(56);
var enumBugKeys = __webpack_require__(37);

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1);
var aCallable = __webpack_require__(50);

var bind = uncurryThis(uncurryThis.bind);

// optional / simple context binding
module.exports = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : bind ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(11);
var global = __webpack_require__(0);
var isArray = __webpack_require__(31);
var isConstructor = __webpack_require__(51);
var isObject = __webpack_require__(5);
var toAbsoluteIndex = __webpack_require__(34);
var lengthOfArrayLike = __webpack_require__(15);
var toIndexedObject = __webpack_require__(10);
var createProperty = __webpack_require__(38);
var wellKnownSymbol = __webpack_require__(4);
var arrayMethodHasSpeciesSupport = __webpack_require__(29);
var un$Slice = __webpack_require__(88);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');

var SPECIES = wellKnownSymbol('species');
var Array = global.Array;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = lengthOfArrayLike(O);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (isConstructor(Constructor) && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return un$Slice(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(11);
var uncurryThis = __webpack_require__(1);
var IndexedObject = __webpack_require__(33);
var toIndexedObject = __webpack_require__(10);
var arrayMethodIsStrict = __webpack_require__(58);

var un$Join = uncurryThis([].join);

var ES3_STRINGS = IndexedObject != Object;
var STRICT_METHOD = arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
$({ target: 'Array', proto: true, forced: ES3_STRINGS || !STRICT_METHOD }, {
  join: function join(separator) {
    return un$Join(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $forEach = __webpack_require__(57).forEach;
var arrayMethodIsStrict = __webpack_require__(58);

var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(8);

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1);

module.exports = uncurryThis([].slice);


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(11);
var exec = __webpack_require__(66);

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(7);
var definePropertyModule = __webpack_require__(9);
var anObject = __webpack_require__(8);
var toIndexedObject = __webpack_require__(10);
var objectKeys = __webpack_require__(82);

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(14);

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(3);
var global = __webpack_require__(0);

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp = global.RegExp;

var UNSUPPORTED_Y = fails(function () {
  var re = $RegExp('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y || fails(function () {
  return !$RegExp('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y || fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});

module.exports = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y
};


/***/ }),
/* 93 */,
/* 94 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var toAbsoluteIndex = __webpack_require__(34);
var lengthOfArrayLike = __webpack_require__(15);
var createProperty = __webpack_require__(38);

var Array = global.Array;
var max = Math.max;

module.exports = function (O, start, end) {
  var length = lengthOfArrayLike(O);
  var k = toAbsoluteIndex(start, length);
  var fin = toAbsoluteIndex(end === undefined ? length : end, length);
  var result = Array(max(fin - k, 0));
  for (var n = 0; k < fin; k++, n++) createProperty(result, n, O[k]);
  result.length = n;
  return result;
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__(10);
var addToUnscopables = __webpack_require__(111);
var Iterators = __webpack_require__(94);
var InternalStateModule = __webpack_require__(44);
var defineIterator = __webpack_require__(115);

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(11);
var $filter = __webpack_require__(57).filter;
var arrayMethodHasSpeciesSupport = __webpack_require__(29);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 98 */
/***/ (function(module, exports) {

var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var bind = FunctionPrototype.bind;
var call = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || (bind ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(9).f;
var hasOwn = __webpack_require__(6);
var wellKnownSymbol = __webpack_require__(4);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (it, TAG, STATIC) {
  if (it && !hasOwn(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1);
var toIntegerOrInfinity = __webpack_require__(19);
var toString = __webpack_require__(30);
var requireObjectCoercible = __webpack_require__(21);

var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var stringSlice = uncurryThis(''.slice);

var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString(requireObjectCoercible($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(11);
var $map = __webpack_require__(57).map;
var arrayMethodHasSpeciesSupport = __webpack_require__(29);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(3);
var global = __webpack_require__(0);

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('.', 's');
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(3);
var global = __webpack_require__(0);

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__(89);
var uncurryThis = __webpack_require__(1);
var redefine = __webpack_require__(18);
var regexpExec = __webpack_require__(66);
var fails = __webpack_require__(3);
var wellKnownSymbol = __webpack_require__(4);
var createNonEnumerableProperty = __webpack_require__(13);

var SPECIES = wellKnownSymbol('species');
var RegExpPrototype = RegExp.prototype;

module.exports = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var uncurriedNativeRegExpMethod = uncurryThis(/./[SYMBOL]);
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var uncurriedNativeMethod = uncurryThis(nativeMethod);
      var $exec = regexp.exec;
      if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
        }
        return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
      }
      return { done: false };
    });

    redefine(String.prototype, KEY, methods[0]);
    redefine(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__(100).charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var call = __webpack_require__(12);
var anObject = __webpack_require__(8);
var isCallable = __webpack_require__(2);
var classof = __webpack_require__(17);
var regexpExec = __webpack_require__(66);

var TypeError = global.TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (isCallable(exec)) {
    var result = call(exec, R, S);
    if (result !== null) anObject(result);
    return result;
  }
  if (classof(R) === 'RegExp') return call(regexpExec, R, S);
  throw TypeError('RegExp#exec called on incompatible receiver');
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(3);
var isCallable = __webpack_require__(2);
var create = __webpack_require__(63);
var getPrototypeOf = __webpack_require__(108);
var redefine = __webpack_require__(18);
var wellKnownSymbol = __webpack_require__(4);
var IS_PURE = __webpack_require__(55);

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype == undefined || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) {
  redefine(IteratorPrototype, ITERATOR, function () {
    return this;
  });
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var hasOwn = __webpack_require__(6);
var isCallable = __webpack_require__(2);
var toObject = __webpack_require__(16);
var sharedKey = __webpack_require__(45);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(122);

var IE_PROTO = sharedKey('IE_PROTO');
var Object = global.Object;
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof Object ? ObjectPrototype : null;
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-proto -- safe */
var uncurryThis = __webpack_require__(1);
var anObject = __webpack_require__(8);
var aPossiblePrototype = __webpack_require__(112);

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = uncurryThis(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(5);
var classof = __webpack_require__(17);
var wellKnownSymbol = __webpack_require__(4);

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(4);
var create = __webpack_require__(63);
var definePropertyModule = __webpack_require__(9);

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var isCallable = __webpack_require__(2);

var String = global.String;
var TypeError = global.TypeError;

module.exports = function (argument) {
  if (typeof argument == 'object' || isCallable(argument)) return argument;
  throw TypeError("Can't set " + String(argument) + ' as a prototype');
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var DOMIterables = __webpack_require__(78);
var DOMTokenListPrototype = __webpack_require__(79);
var ArrayIteratorMethods = __webpack_require__(96);
var createNonEnumerableProperty = __webpack_require__(13);
var wellKnownSymbol = __webpack_require__(4);

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(1);
var PROPER_FUNCTION_NAME = __webpack_require__(42).PROPER;
var redefine = __webpack_require__(18);
var anObject = __webpack_require__(8);
var isPrototypeOf = __webpack_require__(54);
var $toString = __webpack_require__(30);
var fails = __webpack_require__(3);
var regExpFlags = __webpack_require__(87);

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var n$ToString = RegExpPrototype[TO_STRING];
var getFlags = uncurryThis(regExpFlags);

var NOT_GENERIC = fails(function () { return n$ToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME && n$ToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var p = $toString(R.source);
    var rf = R.flags;
    var f = $toString(rf === undefined && isPrototypeOf(RegExpPrototype, R) && !('flags' in RegExpPrototype) ? getFlags(R) : rf);
    return '/' + p + '/' + f;
  }, { unsafe: true });
}


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(11);
var call = __webpack_require__(12);
var IS_PURE = __webpack_require__(55);
var FunctionName = __webpack_require__(42);
var isCallable = __webpack_require__(2);
var createIteratorConstructor = __webpack_require__(121);
var getPrototypeOf = __webpack_require__(108);
var setPrototypeOf = __webpack_require__(109);
var setToStringTag = __webpack_require__(99);
var createNonEnumerableProperty = __webpack_require__(13);
var redefine = __webpack_require__(18);
var wellKnownSymbol = __webpack_require__(4);
var Iterators = __webpack_require__(94);
var IteratorsCore = __webpack_require__(107);

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
          redefine(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    redefine(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
  }
  Iterators[NAME] = defaultIterator;

  return methods;
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(11);
var global = __webpack_require__(0);
var toAbsoluteIndex = __webpack_require__(34);
var toIntegerOrInfinity = __webpack_require__(19);
var lengthOfArrayLike = __webpack_require__(15);
var toObject = __webpack_require__(16);
var arraySpeciesCreate = __webpack_require__(48);
var createProperty = __webpack_require__(38);
var arrayMethodHasSpeciesSupport = __webpack_require__(29);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');

var TypeError = global.TypeError;
var max = Math.max;
var min = Math.min;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = 'Maximum allowed length exceeded';

// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min(max(toIntegerOrInfinity(deleteCount), 0), len - actualStart);
    }
    if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER) {
      throw TypeError(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
    }
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) delete O[k - 1];
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    O.length = len - actualDeleteCount + insertCount;
    return A;
  }
});


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var apply = __webpack_require__(98);
var call = __webpack_require__(12);
var uncurryThis = __webpack_require__(1);
var fixRegExpWellKnownSymbolLogic = __webpack_require__(104);
var isRegExp = __webpack_require__(110);
var anObject = __webpack_require__(8);
var requireObjectCoercible = __webpack_require__(21);
var speciesConstructor = __webpack_require__(118);
var advanceStringIndex = __webpack_require__(105);
var toLength = __webpack_require__(61);
var toString = __webpack_require__(30);
var getMethod = __webpack_require__(60);
var arraySlice = __webpack_require__(95);
var callRegExpExec = __webpack_require__(106);
var regexpExec = __webpack_require__(66);
var stickyHelpers = __webpack_require__(92);
var fails = __webpack_require__(3);

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
var MAX_UINT32 = 0xFFFFFFFF;
var min = Math.min;
var $push = [].push;
var exec = uncurryThis(/./.exec);
var push = uncurryThis($push);
var stringSlice = uncurryThis(''.slice);

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

// @@split logic
fixRegExpWellKnownSymbolLogic('split', function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = toString(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) {
        return call(nativeSplit, string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = call(regexpExec, separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          push(output, stringSlice(string, lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) apply($push, output, arraySlice(match, 1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !exec(separatorCopy, '')) push(output, '');
      } else push(output, stringSlice(string, lastLastIndex));
      return output.length > lim ? arraySlice(output, 0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : call(nativeSplit, this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = separator == undefined ? undefined : getMethod(separator, SPLIT);
      return splitter
        ? call(splitter, separator, O, limit)
        : call(internalSplit, toString(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (string, limit) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);

      if (res.done) return res.value;

      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (UNSUPPORTED_Y ? 'g' : 'y');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
        var z = callRegExpExec(splitter, UNSUPPORTED_Y ? stringSlice(S, q) : S);
        var e;
        if (
          z === null ||
          (e = min(toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          push(A, stringSlice(S, p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            push(A, z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      push(A, stringSlice(S, p));
      return A;
    }
  ];
}, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(8);
var aConstructor = __webpack_require__(119);
var wellKnownSymbol = __webpack_require__(4);

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aConstructor(S);
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var isConstructor = __webpack_require__(51);
var tryToString = __webpack_require__(64);

var TypeError = global.TypeError;

// `Assert: IsConstructor(argument) is true`
module.exports = function (argument) {
  if (isConstructor(argument)) return argument;
  throw TypeError(tryToString(argument) + ' is not a constructor');
};


/***/ }),
/* 120 */,
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__(107).IteratorPrototype;
var create = __webpack_require__(63);
var createPropertyDescriptor = __webpack_require__(20);
var setToStringTag = __webpack_require__(99);
var Iterators = __webpack_require__(94);

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(3);

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(4);

exports.f = wellKnownSymbol;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__(143);
var hasOwn = __webpack_require__(6);
var wrappedWellKnownSymbolModule = __webpack_require__(127);
var defineProperty = __webpack_require__(9).f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!hasOwn(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var array = __webpack_require__(155);

var chart = __webpack_require__(164);

var fn = __webpack_require__(165);

var object = __webpack_require__(141);

var str = __webpack_require__(166);

var svg = __webpack_require__(167);

var colors = __webpack_require__(168);

var number = __webpack_require__(169);

var generators = __webpack_require__(170);
/** @module Core/Utils */


module.exports = {
  assign: object.assign,
  callFn: fn.call,
  clone: object.clone,
  convertDashToEnDash: str.convertDashToEnDash,
  copy: object.copy,
  dashify: str.dashify,
  extract: object.extract,
  getBoolean: object.getBoolean,
  getDomain: chart.getDomain,
  getGreaterSVGTextWidth: svg.getGreaterSVGTextWidth,
  getRoundToUnits: array.getRoundToUnits,
  getStackedValues: array.getStackedValues,
  getSVGTextWidth: svg.getSVGTextWidth,
  getTickValues: chart.getTickValues,
  hasNegative: array.hasNegative,
  indexOf: array.indexOf,
  isUndefined: object.isUndefined,
  minmax: array.minmax,
  NaNtoNull: object.NaNtoNull,
  removeDuplicates: array.removeDuplicates,
  template: str.template,
  UID: str.UID,
  array: array,
  chart: chart,
  fn: fn,
  object: object,
  string: str,
  svg: svg,
  colors: colors,
  number: number,
  generators: generators
};

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__(2);
var isObject = __webpack_require__(5);
var setPrototypeOf = __webpack_require__(109);

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
 // jscs:disable safeContextKeyword

__webpack_require__(137);

__webpack_require__(138);

__webpack_require__(139);

__webpack_require__(96);

__webpack_require__(140);

__webpack_require__(113);

__webpack_require__(97);

__webpack_require__(49);

__webpack_require__(116);

__webpack_require__(65);

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var Utils = __webpack_require__(129);
/**
 * Base object. Provides a way to Class inheritance and use of mixins.
 *
 * @example {@lang javascript}
 *  // Simple extension.
 *
 *  // Creates a Person class extending from Base.
 *  var Person = Base.extend({
 *      name: "John",
 *      greet: function () { return "Hello, my name is" + this.get("name") + ".";}
 *  });
 *  var person = new Person();
 *  person.greet(); // "Hello, my name is John."
 *
 *  // Extending Person
 *  var Musician = Person.extend({
 *      name: "Wolfgang",
 *      instrument: "Violin",
 *      greet: function () { return this.__super__.greet.call(this) + " I play the " + this.get("instrument"); }
 *  });
 *
 *  var mozart = new Musician();
 *  mozart.greet()  // Hello, my name is Wolfgang. I play the Violin.
 *
 *  mozart.set("instrument", "Piano");
 *  mozart.greet()  // Hello, my name is Wolfgang. I play the Piano.
 * @example
 *  // Extension with mixins
 *
 *  // Mixin definition
 *  function DriverMixin () {}
 *  DriverMixin.prototype.drive = function() { return this.get("name") + "is driving a" + this.get("vehicle"); };
 *
 *  var Driver = Person.extend(DriverMixin, {
 *      vehicle: "Motorcycle"
 *  })
 *
 *  var juanPabloMontoya = new Driver();
 *
 *  juanPabloMontoya.drive(); // "John is driving a motorcycle"  <-- That's incorrect
 *  juanPabloMontoya.set("name", "Juan Pablo");
 *  juanPabloMontoya.set("vehicle", "Formula Car");
 *  juanPabloMontoya.drive(); // "Juan Pablo is driving a Formula Car"  <-- Now That's correct
 * @param {Object} options Class' instance attributes to be setted. Overrides existing ones or create a new attribute if it does not exist.
 * @constructor
 */


var Base = function Base() {};

Base.prototype = {
  __attributes: null,
  __watchers: null,

  /**
   * Sets the <i>value</i> under the passed <i>key</i> into the attributes's store.
   * @param {any} key Name of the attribute to store.
   * @param {any} value Attribute's value.
   * @returns {Base} object's instance to allow chainability.
   */
  set: function set(key, value) {
    this.__attributes[key] = value;

    this._checkWatcher(key, value);

    return this;
  },

  /**
   * Search the attribute's store and returns its value.
   * @param {any} key Attribute's key to retrieve.
   * @returns {Object} Attribute's value.
   */
  get: function get(key) {
    return this.__attributes[key];
  },

  /**
   * Initialize object attributes.
   */
  _initAttrs: function _initAttrs(options) {
    for (var key in options) {
      this.set(key, options[key]);
    }
  },

  /**
   * Set an attribute bound watcher.
   * @param {String} attribute Attribute's name.
   * @param {Function} handler Method to execute when the attribute changes.
   */
  watch: function watch(attribute, handler) {
    var watcher = this.__watchers[attribute];
    var handlers, length, value;

    if (watcher) {
      handlers = watcher.handlers;
      length = handlers.filter(function (fn) {
        return "" + fn === "" + handler;
      }).length;

      if (!length) {
        handlers.push(handler);
      }
    } else {
      value = this.__attributes ? this.__attributes[attribute] : undefined;
      this.__watchers[attribute] = {
        oldValue: value,
        handlers: [handler]
      };
    }
  },

  /**
   * Remove all handlers attached to an attribute key or just the one that contains the specified handler if it is passed as paramter
   * @param {String} attribute Attribute's name.
   * @param {Function} handler Optional. If not passed removes all handlers attached to the attribute.
   */
  unwatch: function unwatch(attribute, handler) {
    var watcher = this.__watchers[attribute];
    var handlers;

    if (watcher) {
      if (!handler) {
        delete this.__watchers[attribute];
      } else {
        handlers = watcher.handlers;
        handlers.splice(handlers.indexOf(handler), 1);
      }
    }
  },

  /**
   * Removes all attributes watchers.
   */
  unwatchAll: function unwatchAll() {
    this.__watchers = {};
  },

  /**
   * Checks if the attribute have been modified and execute the handler function.
   * @param {String} attribute Attribute's name.
   * @param {Object} newValue New attribute's value.
   */
  _checkWatcher: function _checkWatcher(attribute, newValue) {
    var watcher = this.__watchers[attribute];

    if (watcher && newValue !== watcher.oldValue) {
      watcher.handlers.forEach(function (handler) {
        handler(newValue, watcher.oldValue);
        watcher.oldValue = newValue;
      });
    }
  }
};
/**
 * Method that returns a new class extending the class that calls it. If mixins are
 * passed its methods are extended to the resultant class too.
 * @static
 * @returns {Class}
 */

Base.extend = function () {
  var properties = {};
  var mixins = [];
  var i = 0;
  var arg = arguments[i++];
  var parent = this;
  var parentDefaults = parent.prototype.__defaults__ || {};
  var defaults = {};
  var child, key, value;
  Utils.object.copy(defaults, parentDefaults);

  while (_typeof(arg) !== "object") {
    mixins.push(arg);
    arg = arguments[i++];
  }

  properties = arg;

  child = function child(options) {
    parent.apply(this, arguments);
    this.__attributes = this.__attributes || {
      _id: new Date().getTime()
    };
    this.__watchers = {};

    for (key in this.__defaults__) {
      if (!this.__attributes[key]) {
        this.__attributes[key] = this.__defaults__[key];
      }
    } // Apply options


    if (options) {
      this._initAttrs(options);
    }

    if (properties.initializer && typeof properties.initializer === "function") {
      properties.initializer.call(this);
    }

    mixins.forEach(function (mixin) {
      if (mixin.prototype.initializer) {
        mixin.prototype.initializer.call(this);
      }
    }.bind(this));
  }; // Copying statics from old class to new one.


  for (key in parent) {
    if (parent.hasOwnProperty(key)) {
      child[key] = parent[key];
    }
  }

  child.prototype = Object.create(parent.prototype);

  for (key in parent.prototype) {
    value = parent.prototype[key];

    if (typeof value !== "function") {
      if (key !== "attributes" && key !== "__super__" && key !== "__defaults__") {
        defaults[key] = value;
      }
    }
  } // Adding/overwriting new properties into child prototype.


  if (properties) {
    for (key in properties) {
      if (properties.hasOwnProperty(key)) {
        value = properties[key];

        if (typeof value === "function") {
          child.prototype[key] = value;
        } else if (key !== "attributes" && key !== "__super__" && key !== "__defaults__") {
          defaults[key] = value;
        }
      }
    }
  }

  mixins.forEach(function (mixin) {
    Utils.object.copy(child.prototype, mixin.prototype);
  });
  child.prototype.__defaults__ = Utils.object.clone(defaults);
  child.prototype.__super__ = parent.prototype;
  return child;
};

module.exports = Base;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(11);
var global = __webpack_require__(0);
var getBuiltIn = __webpack_require__(14);
var apply = __webpack_require__(98);
var call = __webpack_require__(12);
var uncurryThis = __webpack_require__(1);
var IS_PURE = __webpack_require__(55);
var DESCRIPTORS = __webpack_require__(7);
var NATIVE_SYMBOL = __webpack_require__(46);
var fails = __webpack_require__(3);
var hasOwn = __webpack_require__(6);
var isArray = __webpack_require__(31);
var isCallable = __webpack_require__(2);
var isObject = __webpack_require__(5);
var isPrototypeOf = __webpack_require__(54);
var isSymbol = __webpack_require__(43);
var anObject = __webpack_require__(8);
var toObject = __webpack_require__(16);
var toIndexedObject = __webpack_require__(10);
var toPropertyKey = __webpack_require__(22);
var $toString = __webpack_require__(30);
var createPropertyDescriptor = __webpack_require__(20);
var nativeObjectCreate = __webpack_require__(63);
var objectKeys = __webpack_require__(82);
var getOwnPropertyNamesModule = __webpack_require__(62);
var getOwnPropertyNamesExternal = __webpack_require__(142);
var getOwnPropertySymbolsModule = __webpack_require__(68);
var getOwnPropertyDescriptorModule = __webpack_require__(41);
var definePropertyModule = __webpack_require__(9);
var propertyIsEnumerableModule = __webpack_require__(67);
var arraySlice = __webpack_require__(88);
var redefine = __webpack_require__(18);
var shared = __webpack_require__(35);
var sharedKey = __webpack_require__(45);
var hiddenKeys = __webpack_require__(27);
var uid = __webpack_require__(47);
var wellKnownSymbol = __webpack_require__(4);
var wrappedWellKnownSymbolModule = __webpack_require__(127);
var defineWellKnownSymbol = __webpack_require__(128);
var setToStringTag = __webpack_require__(99);
var InternalStateModule = __webpack_require__(44);
var $forEach = __webpack_require__(57).forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);

var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE];
var TypeError = global.TypeError;
var QObject = global.QObject;
var $stringify = getBuiltIn('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var push = uncurryThis([].push);

var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');
var WellKnownSymbolsStore = shared('wks');

// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPropertyKey(P);
  anObject(Attributes);
  if (hasOwn(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!hasOwn(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (hasOwn(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || call($propertyIsEnumerable, properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPropertyKey(V);
  var enumerable = call(nativePropertyIsEnumerable, this, P);
  if (this === ObjectPrototype && hasOwn(AllSymbols, P) && !hasOwn(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !hasOwn(this, P) || !hasOwn(AllSymbols, P) || hasOwn(this, HIDDEN) && this[HIDDEN][P]
    ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPropertyKey(P);
  if (it === ObjectPrototype && hasOwn(AllSymbols, key) && !hasOwn(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && hasOwn(AllSymbols, key) && !(hasOwn(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!hasOwn(AllSymbols, key) && !hasOwn(hiddenKeys, key)) push(result, key);
  });
  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (hasOwn(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn(ObjectPrototype, key))) {
      push(result, AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (isPrototypeOf(SymbolPrototype, this)) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) call(setter, ObjectPrototypeSymbols, value);
      if (hasOwn(this, HIDDEN) && hasOwn(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  SymbolPrototype = $Symbol[PROTOTYPE];

  redefine(SymbolPrototype, 'toString', function toString() {
    return getInternalState(this).tag;
  });

  redefine($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty(SymbolPrototype, 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  // `Symbol.for` method
  // https://tc39.es/ecma262/#sec-symbol.for
  'for': function (key) {
    var string = $toString(key);
    if (hasOwn(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.es/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
    if (hasOwn(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.es/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
$({ target: 'Object', stat: true, forced: fails(function () { getOwnPropertySymbolsModule.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return getOwnPropertySymbolsModule.f(toObject(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.es/ecma262/#sec-json.stringify
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return $stringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
  });

  $({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = arraySlice(arguments);
      var $replacer = replacer;
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!isArray(replacer)) replacer = function (key, value) {
        if (isCallable($replacer)) value = call($replacer, this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return apply($stringify, null, args);
    }
  });
}

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
if (!SymbolPrototype[TO_PRIMITIVE]) {
  var valueOf = SymbolPrototype.valueOf;
  // eslint-disable-next-line no-unused-vars -- required for .length
  redefine(SymbolPrototype, TO_PRIMITIVE, function (hint) {
    // TODO: improve hint logic
    return call(valueOf, this);
  });
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__(11);
var DESCRIPTORS = __webpack_require__(7);
var global = __webpack_require__(0);
var uncurryThis = __webpack_require__(1);
var hasOwn = __webpack_require__(6);
var isCallable = __webpack_require__(2);
var isPrototypeOf = __webpack_require__(54);
var toString = __webpack_require__(30);
var defineProperty = __webpack_require__(9).f;
var copyConstructorProperties = __webpack_require__(70);

var NativeSymbol = global.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString(arguments[0]);
    var result = isPrototypeOf(SymbolPrototype, this)
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('test')) == 'Symbol(test)';
  var symbolToString = uncurryThis(SymbolPrototype.toString);
  var symbolValueOf = uncurryThis(SymbolPrototype.valueOf);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace = uncurryThis(''.replace);
  var stringSlice = uncurryThis(''.slice);

  defineProperty(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = symbolValueOf(this);
      var string = symbolToString(symbol);
      if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
      var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(128);

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__(100).charAt;
var toString = __webpack_require__(30);
var InternalStateModule = __webpack_require__(44);
var defineIterator = __webpack_require__(115);

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: toString(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Given a path it extract a value from a complex deep object.
 *
 * @param {Object} obj
 * @param {String} path
 * @returns Object's value found in the given path.
 */

__webpack_require__(144);

__webpack_require__(163);

function getPath(obj, path) {
  var index, prefix, subpath;

  if (!obj || !path || typeof path !== "string" || path === "") {
    return;
  }

  index = path.indexOf(".");

  if (index === -1) {
    return obj[path];
  } else {
    prefix = path.substring(0, index);
    subpath = path.substring(index + 1);
    return getPath(obj[prefix], subpath);
  }
}
/**
 * Copy source object properties into a target one.
 *
 * @export
 * @param {Object} target Target object.
 * @param {Object} source Source Object
 */


var copy = function copy(target) {
  var key, source;

  if (!target) {
    return;
  }

  for (var i = 1; i < arguments.length; i++) {
    source = arguments[i];

    for (key in source) {
      if (source.hasOwnProperty(key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};
/**
 * Extracts a value using an accessor or the same value if no accessor.
 * @param {Object} item Contains the value.
 * @param {Function|String}? accessor Accessor function or field that contains the value.
 * @param {Object} params Parameters to pass to the accessor function.
 * @return {Object} Value.
 */


var extract = function extract(item, accessor, params) {
  var value;

  if (typeof accessor === "undefined") {
    value = item;
  } else if (typeof accessor === "function") {
    value = accessor(item, params);
  } else if (typeof accessor === "string") {
    value = item[accessor];
  }

  return value;
};
/**
 * Clones an object.
 *
 * @export
 * @param {Object} target Object to clone.
 * @returns {Object} Cloned object.
 */


var clone = function clone(target) {
  if (target === undefined || target === null) {
    throw new TypeError("Cannot convert first argument to object");
  }

  var to = Object(target);

  for (var i = 1; i < arguments.length; i++) {
    var nextSource = arguments[i];

    if (nextSource === undefined || nextSource === null) {
      continue;
    }

    var keysArray = Object.keys(Object(nextSource));

    for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
      var nextKey = keysArray[nextIndex];
      var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);

      if (desc !== undefined && desc.enumerable) {
        to[nextKey] = nextSource[nextKey];
      }
    }
  }

  return to;
};
/**
 * If just the value is passed return a boolean indicated is the value is undefined.
 * If the second parameter exists if value is undefined retunrs the second parameter, if not returns the value.
 * @param {Obect} value Object to evaluate.
 * @param {Object} defaultValue Object to return in case vale¡ue is undefined.
 */


var isUndefined = function isUndefined(value, defaultValue) {
  if (typeof defaultValue !== "undefined") return typeof value === "undefined" ? defaultValue : value;else return typeof value === "undefined";
};
/**
 * Check if the given value is not a number then return null, if it is a number return the number.
 * @param {Object} val Value to check.
 * @returns {undefined|Number}
 */


var NaNtoNull = function NaNtoNull(val) {
  if (typeof val !== "number" || isNaN(val) || val === Infinity) {
    return null;
  } else {
    return val;
  }
};
/**
 * Method to get the boolean value, if not it returns a default value.
 * @param {Object} value Value to check if it is a boolean.
 * @param {Boolean} defaultValue Default value in case value is not a boolean.
 * @returns {Boolean}
 */


var getBoolean = function getBoolean(value, defaultValue) {
  return typeof value === "boolean" ? value : defaultValue;
};

var assign = function assign(target) {
  // .length of function is 2
  if (target == null) {
    // TypeError if undefined or null
    throw new TypeError('Cannot convert undefined or null to object');
  }

  var to = Object(target);

  for (var index = 1; index < arguments.length; index++) {
    var nextSource = arguments[index];

    if (nextSource != null) {
      // Skip over if undefined or null
      for (var nextKey in nextSource) {
        // Avoid bugs when hasOwnProperty is shadowed
        if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
          to[nextKey] = nextSource[nextKey];
        }
      }
    }
  }

  return to;
};

module.exports = {
  clone: clone,
  copy: copy,
  extract: extract,
  getBoolean: getBoolean,
  isUndefined: isUndefined,
  NaNtoNull: NaNtoNull,
  path: getPath,
  assign: assign
};

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-object-getownpropertynames -- safe */
var classof = __webpack_require__(17);
var toIndexedObject = __webpack_require__(10);
var $getOwnPropertyNames = __webpack_require__(62).f;
var arraySlice = __webpack_require__(95);

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return arraySlice(windowNames);
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && classof(it) == 'Window'
    ? getWindowNames(it)
    : $getOwnPropertyNames(toIndexedObject(it));
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);

module.exports = global;


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(11);
var toObject = __webpack_require__(16);
var nativeKeys = __webpack_require__(82);
var fails = __webpack_require__(3);

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var apply = __webpack_require__(98);
var call = __webpack_require__(12);
var uncurryThis = __webpack_require__(1);
var fixRegExpWellKnownSymbolLogic = __webpack_require__(104);
var fails = __webpack_require__(3);
var anObject = __webpack_require__(8);
var isCallable = __webpack_require__(2);
var toIntegerOrInfinity = __webpack_require__(19);
var toLength = __webpack_require__(61);
var toString = __webpack_require__(30);
var requireObjectCoercible = __webpack_require__(21);
var advanceStringIndex = __webpack_require__(105);
var getMethod = __webpack_require__(60);
var getSubstitution = __webpack_require__(146);
var regExpExec = __webpack_require__(106);
var wellKnownSymbol = __webpack_require__(4);

var REPLACE = wellKnownSymbol('replace');
var max = Math.max;
var min = Math.min;
var concat = uncurryThis([].concat);
var push = uncurryThis([].push);
var stringIndexOf = uncurryThis(''.indexOf);
var stringSlice = uncurryThis(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = searchValue == undefined ? undefined : getMethod(searchValue, REPLACE);
      return replacer
        ? call(replacer, searchValue, O, replaceValue)
        : call(nativeReplace, toString(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject(this);
      var S = toString(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable(replaceValue);
      if (!functionalReplace) replaceValue = toString(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;

        push(results, result);
        if (!global) break;

        var matchStr = toString(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString(result[0]);
        var position = max(min(toIntegerOrInfinity(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat([matched], captures, position, S);
          if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
          var replacement = toString(apply(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + stringSlice(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1);
var toObject = __webpack_require__(16);

var floor = Math.floor;
var charAt = uncurryThis(''.charAt);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
module.exports = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice(str, 0, position);
      case "'": return stringSlice(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(7);
var global = __webpack_require__(0);
var uncurryThis = __webpack_require__(1);
var isForced = __webpack_require__(69);
var inheritIfRequired = __webpack_require__(130);
var createNonEnumerableProperty = __webpack_require__(13);
var defineProperty = __webpack_require__(9).f;
var getOwnPropertyNames = __webpack_require__(62).f;
var isPrototypeOf = __webpack_require__(54);
var isRegExp = __webpack_require__(110);
var toString = __webpack_require__(30);
var regExpFlags = __webpack_require__(87);
var stickyHelpers = __webpack_require__(92);
var redefine = __webpack_require__(18);
var fails = __webpack_require__(3);
var hasOwn = __webpack_require__(6);
var enforceInternalState = __webpack_require__(44).enforce;
var setSpecies = __webpack_require__(148);
var wellKnownSymbol = __webpack_require__(4);
var UNSUPPORTED_DOT_ALL = __webpack_require__(102);
var UNSUPPORTED_NCG = __webpack_require__(103);

var MATCH = wellKnownSymbol('match');
var NativeRegExp = global.RegExp;
var RegExpPrototype = NativeRegExp.prototype;
var SyntaxError = global.SyntaxError;
var getFlags = uncurryThis(regExpFlags);
var exec = uncurryThis(RegExpPrototype.exec);
var charAt = uncurryThis(''.charAt);
var replace = uncurryThis(''.replace);
var stringIndexOf = uncurryThis(''.indexOf);
var stringSlice = uncurryThis(''.slice);
// TODO: Use only propper RegExpIdentifierName
var IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var MISSED_STICKY = stickyHelpers.MISSED_STICKY;
var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;

var BASE_FORCED = DESCRIPTORS &&
  (!CORRECT_NEW || MISSED_STICKY || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG || fails(function () {
    re2[MATCH] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    return NativeRegExp(re1) != re1 || NativeRegExp(re2) == re2 || NativeRegExp(re1, 'i') != '/a/i';
  }));

var handleDotAll = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var brackets = false;
  var chr;
  for (; index <= length; index++) {
    chr = charAt(string, index);
    if (chr === '\\') {
      result += chr + charAt(string, ++index);
      continue;
    }
    if (!brackets && chr === '.') {
      result += '[\\s\\S]';
    } else {
      if (chr === '[') {
        brackets = true;
      } else if (chr === ']') {
        brackets = false;
      } result += chr;
    }
  } return result;
};

var handleNCG = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var named = [];
  var names = {};
  var brackets = false;
  var ncg = false;
  var groupid = 0;
  var groupname = '';
  var chr;
  for (; index <= length; index++) {
    chr = charAt(string, index);
    if (chr === '\\') {
      chr = chr + charAt(string, ++index);
    } else if (chr === ']') {
      brackets = false;
    } else if (!brackets) switch (true) {
      case chr === '[':
        brackets = true;
        break;
      case chr === '(':
        if (exec(IS_NCG, stringSlice(string, index + 1))) {
          index += 2;
          ncg = true;
        }
        result += chr;
        groupid++;
        continue;
      case chr === '>' && ncg:
        if (groupname === '' || hasOwn(names, groupname)) {
          throw new SyntaxError('Invalid capture group name');
        }
        names[groupname] = true;
        named[named.length] = [groupname, groupid];
        ncg = false;
        groupname = '';
        continue;
    }
    if (ncg) groupname += chr;
    else result += chr;
  } return [result, named];
};

// `RegExp` constructor
// https://tc39.es/ecma262/#sec-regexp-constructor
if (isForced('RegExp', BASE_FORCED)) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = isPrototypeOf(RegExpPrototype, this);
    var patternIsRegExp = isRegExp(pattern);
    var flagsAreUndefined = flags === undefined;
    var groups = [];
    var rawPattern = pattern;
    var rawFlags, dotAll, sticky, handled, result, state;

    if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === RegExpWrapper) {
      return pattern;
    }

    if (patternIsRegExp || isPrototypeOf(RegExpPrototype, pattern)) {
      pattern = pattern.source;
      if (flagsAreUndefined) flags = 'flags' in rawPattern ? rawPattern.flags : getFlags(rawPattern);
    }

    pattern = pattern === undefined ? '' : toString(pattern);
    flags = flags === undefined ? '' : toString(flags);
    rawPattern = pattern;

    if (UNSUPPORTED_DOT_ALL && 'dotAll' in re1) {
      dotAll = !!flags && stringIndexOf(flags, 's') > -1;
      if (dotAll) flags = replace(flags, /s/g, '');
    }

    rawFlags = flags;

    if (MISSED_STICKY && 'sticky' in re1) {
      sticky = !!flags && stringIndexOf(flags, 'y') > -1;
      if (sticky && UNSUPPORTED_Y) flags = replace(flags, /y/g, '');
    }

    if (UNSUPPORTED_NCG) {
      handled = handleNCG(pattern);
      pattern = handled[0];
      groups = handled[1];
    }

    result = inheritIfRequired(NativeRegExp(pattern, flags), thisIsRegExp ? this : RegExpPrototype, RegExpWrapper);

    if (dotAll || sticky || groups.length) {
      state = enforceInternalState(result);
      if (dotAll) {
        state.dotAll = true;
        state.raw = RegExpWrapper(handleDotAll(pattern), rawFlags);
      }
      if (sticky) state.sticky = true;
      if (groups.length) state.groups = groups;
    }

    if (pattern !== rawPattern) try {
      // fails in old engines, but we have no alternatives for unsupported regex syntax
      createNonEnumerableProperty(result, 'source', rawPattern === '' ? '(?:)' : rawPattern);
    } catch (error) { /* empty */ }

    return result;
  };

  var proxy = function (key) {
    key in RegExpWrapper || defineProperty(RegExpWrapper, key, {
      configurable: true,
      get: function () { return NativeRegExp[key]; },
      set: function (it) { NativeRegExp[key] = it; }
    });
  };

  for (var keys = getOwnPropertyNames(NativeRegExp), index = 0; keys.length > index;) {
    proxy(keys[index++]);
  }

  RegExpPrototype.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype;
  redefine(global, 'RegExp', RegExpWrapper);
}

// https://tc39.es/ecma262/#sec-get-regexp-@@species
setSpecies('RegExp');


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(14);
var definePropertyModule = __webpack_require__(9);
var wellKnownSymbol = __webpack_require__(4);
var DESCRIPTORS = __webpack_require__(7);

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineProperty(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BASE = "mbc";
var CHART = BASE + "-chart";
module.exports = {
  AXES: BASE + "-axes",
  AXIS: BASE + "-axis",
  BACK: BASE + "-back-group",
  CANVAS: BASE + "-canvas",
  CHART_GROUP: CHART + "-group",
  CHART: CHART,
  CHARTS_AREA: CHART + "s-area",
  CONTAINER: CHART + "-container",
  DECK: CHART + "-deck",
  FOCUS: CHART + "-focus",
  FRONT: BASE + "-front-group",
  GRID: BASE + "-grid",
  GRID_LINE: BASE + "-grid-line",
  INNER: CHART + "-inner",
  LAYERS: BASE + "-layers",
  LEGEND_ITEM: CHART + "-legend-item",
  LEGEND: CHART + "-legend",
  TITLE: CHART + "-title",
  TOOLTIP: CHART + "-tooltip",
  TOOLTIP_CONTAINER: CHART + "-tooltip-container",
  ZONES: CHART + "-zones",
  ZONE: CHART + "-zone"
};

/***/ }),
/* 150 */,
/* 151 */,
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** @module Core */

var AxesManager = __webpack_require__(153);

var Canvas = __webpack_require__(154);

var Chart = __webpack_require__(173);

var DataManager = __webpack_require__(158);

var Base = __webpack_require__(136);

var ScalesManager = __webpack_require__(159);

var Utils = __webpack_require__(129);

var Classes = __webpack_require__(149);

var d3Overrides = __webpack_require__(174);

var version = __webpack_require__(175);

var Axes = __webpack_require__(176); // D3 overrides


d3Overrides(); // Sets MBC version on window

version();
module.exports = {
  /**
   * @see AxesManager
   */
  AxesManager: AxesManager,

  /**
   * @see Canvas
   */
  Canvas: Canvas,

  /**
   * @see Chart
   */
  Chart: Chart,

  /**
   * @see Base
   */
  Base: Base,

  /**
   * @see ScalesManager
   */
  ScalesManager: ScalesManager,

  /**
   * @see DataManager
   */
  DataManager: DataManager,

  /**
  * @see Utils
  */
  Utils: Utils,

  /**
   * @see Classes
   */
  Classes: Classes,

  /**
  * @see Axes
  */
  Axes: Axes
};

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Creates an AxesManager instance. AxesManagers centralize chart's axes
 * in order to access them transversely.<br>
 * @example
 * var axesManager = new AxesManager({"x", d3.svg.axis()})
 * @constructor
 * @param {object} axes <i>Optional</i>. A hashmap with chart's axes.
 */

function AxesManager(axes) {
  this._axes = axes || {};
}
/**
 * Sets or returns an axis. If no axis object is passsed then sets the axis.
 * @param  {String} axisName
 * @param  {D3.axis} axis
 *
 * @return {D3.axis}
 */


AxesManager.prototype.axis = function (axisName, axis) {
  if (!axisName) {
    return;
  }

  if (!axis) {
    return this._axes[axisName];
  }

  this._axes[axisName] = axis;
  return axis;
};
/**
 * Remove an axis from the collection.
 * @param {String} axisName Axis to remove.
 */


AxesManager.prototype.remove = function (axisName) {
  delete this._axes[axisName];
};
/**
 * Return the axes store object.
 *
 * @returns {Object} Hashmap that containing the axes.
 */


AxesManager.prototype.axes = function () {
  return this._axes;
};

module.exports = AxesManager;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Base = __webpack_require__(136);

var Classes = __webpack_require__(149);

var Config = __webpack_require__(172);
/**
 * Canvas is in charge of create and calculate dimensions of the svg container where the chart is going to be rendered.
 * Also creates layers that holds chart's parts (axis, chart area, etc.)
 * @constructor
 * @param {D3.selection} container
 * @param {Object} margin
 */


var Canvas = Base.extend(
/**
 *  @lends Canvas.prototype
 **/
{
  /** @type {D3 selection} */
  selection: null,

  /** @type {Object} */
  margin: Config.canvasDefaults.margin,

  /** @type {Number} */
  axesSpacing: Config.canvasDefaults.axesSpacing,

  /** @type {Number} */
  axesPadding: 0,

  /** @type {DOM element} */
  container: null,

  /** @type {DOM element} */
  svg: null,

  /** @type {Number} */
  yAxesLabelWidth: 10,

  /**
   * Sets up the canvas object
   */
  initializer: function initializer() {
    var template = this.get("template");

    if (template && (typeof template === "string" || typeof template === "function")) {
      this.get("selection").html(template);
      this.set("container", this.get("selection").select(".".concat(Classes.INNER))[0][0]);
      this.set("inner", true);
    } else {
      this.set("container", this.get("selection")[0][0]);
    }

    this.calculate();
    this.buildSVG();
  },

  /**
   * Update the canvas.
   * @return {Canvas} this Canvas object.
   */
  update: function update() {
    this.calculate();
    this.buildSVG();
    return this;
  },

  /**
   * Returns the width of chart inner container.
   * @return {Number} Inner container width.
   */
  width: function width() {
    return this.get("width");
  },

  /**
   * Returns the inner container height.
   * @return {Number} Inner container height.
   */
  height: function height() {
    return this.get("height");
  },

  /**
   * Returns the outer container width.
   * @return {Number} Outer container width.
   */
  outerWidth: function outerWidth() {
    return this.get("outerWidth");
  },

  /**
   * Returns the outer container height.
   * @return {Number} Outer container height.
   */
  outerHeight: function outerHeight() {
    return this.get("outerHeight");
  },

  /**
   * Calculates width and height of chart's area.
   */
  calculate: function calculate() {
    var selection = this.get("selection")[0][0];
    var container = this.get("container");
    var margin = this.get("margin");
    this.set("width", container.offsetWidth - margin.left - margin.right);
    this.set("height", container.offsetHeight - margin.top - margin.bottom);
    this.set("outerWidth", selection.offsetWidth);
    this.set("outerHeight", selection.offsetHeight);
  },

  /**
   * Appends the SVG Elements and set its dimensions.
   * @private
   */
  buildSVG: function buildSVG() {
    var svg = this.get("svg");
    var margin = this.get("margin");

    if (!svg) {
      svg = d3.select(this.get("container")).append("svg").attr("role", "figure").classed(Classes.CANVAS, true);
      this.set("svg", svg);
    }

    this.buildContainerGroups();
    svg.attrs({
      width: this.get("width") + margin.left + margin.right,
      height: this.get("height") + margin.top + margin.bottom
    });
  },

  /**
   * Build layered contaiers for each charts components in this order:.
   *
   * <li> Axes layer. </li>
   * <li> Behind chart layer. </li>
   * <li> Chart layer. </li>
   * <li> Front Chart layer. </li>
   * @private
   */
  buildContainerGroups: function buildContainerGroups() {
    var margin = this.get("margin");
    var svg = this.get("svg");
    var groups = svg.select(".".concat(Classes.LAYERS));

    if (groups.empty()) {
      groups = svg.append("g").classed(Classes.LAYERS, true);
      this.set("axesGroup", groups.append("g").classed(Classes.AXES, true));
      this.set("backGroup", groups.append("g").classed(Classes.BACK, true));
      this.set("chartGroup", groups.append("g").classed(Classes.CHART_GROUP, true));
      this.set("frontGroup", groups.append("g").classed(Classes.FRONT, true));
    }

    groups.attrs({
      transform: "translate(" + margin.left + "," + margin.top + ")"
    });
  },

  /**
   * Returns a layer inside the chart area, if it does not exist creates it unless avoidCreate is true.
   *
   * @param {String} layerName
   * @param {String} groupName axes, back, front, chart.
   * @param {Boolean} avoidCreate
   * @returns {D3.Selection}
   */
  layer: function layer(layerName, groupName, avoidCreate) {
    groupName = (groupName || "chart") + "Group";
    var group = this.get(groupName);
    var layer = group.select("." + layerName);

    if (!avoidCreate && layer.empty()) {
      layer = group.append("g").classed(layerName, true);
    }

    return layer;
  },

  /**
   * Removes a layer inside the given group.
   *
   * @param {String} layerName
   * @param {String} groupName axes, back, front, chart.
   * @returns {D3.Selection}
   */
  removeLayer: function removeLayer(layerName, groupName) {
    groupName = (groupName || "chart") + "Group";
    var group = this.get(groupName);
    group.select("." + layerName).remove();
  },

  /**
   * Remove the old axes (if they exist) and add the new axes into the axes layer.
   *
   * @param {AxesManager} axesManager AxesManager containing updated axes.
   */
  drawAxes: function drawAxes(axesManager) {
    var axes = axesManager.axes();
    var axesCount = {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    };
    var axesGroup = this.get("axesGroup");
    var yAxesLabelWidth = this.get("yAxesLabelWidth");
    var axesSpacing = this.get("axesSpacing") + yAxesLabelWidth;
    var axesPadding = this.get("axesPadding");
    var key, axis, translate, orient, count, tickSize, calc;
    axesGroup.selectAll("." + Classes.AXIS).remove();

    for (key in axes) {
      var _axesGroup$append$cla;

      axis = axes[key];
      orient = axis.orient();
      count = axesCount[orient];
      tickSize = axis.tickSize();

      switch (orient) {
        case "bottom":
          translate = "translate(0, " + this.get("height") + ")";
          break;

        case "right":
          calc = axesPadding + (this.get("width") + count * (axesSpacing + tickSize));
          translate = "translate(" + calc + ", 0)";
          break;

        case "top":
          translate = "translate(0, 0)";
          break;

        case "left":
          calc = 0 - axesPadding - count * (axesSpacing + tickSize);
          translate = "translate(" + calc + ", 0)";
          break;

        default:
          break;
      }

      axesCount[orient]++;
      axesGroup.append("g").classed((_axesGroup$append$cla = {}, _defineProperty(_axesGroup$append$cla, Classes.AXIS, true), _defineProperty(_axesGroup$append$cla, Classes.AXIS + "-" + key, true), _defineProperty(_axesGroup$append$cla, Classes.AXIS + "-" + orient, true), _axesGroup$append$cla)).attr("transform", translate).call(axis);
    }
  },

  /**
   * Removes the canvas from the container and reset the watchers object.
   */
  remove: function remove() {
    this.unwatchAll();
    this.get("selection").selectAll("*").remove();
  }
});
module.exports = Canvas;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(101);

__webpack_require__(97);

__webpack_require__(49);

__webpack_require__(89);

__webpack_require__(117);

__webpack_require__(156);

var extract = __webpack_require__(141).extract;
/**
 * Returns true if an array contains just null values. If the parameter is a falsey value returns undefined.
 * @example
 * Util.array.hasNulls([null, null, null]) // returns true
 *  @param {Array} arr Array to inspect.
 * @return {Boolean} true means that the array contains null values.
 **/


var hasNulls = function hasNulls(arr) {
  if (!arr) return;
  var len = arr.length;
  var i = 0;

  for (; i < len; i++) {
    if (arr[i] !== null) {
      return false;
    }
  }

  return true;
};
/**
 * Returns false if the array passed contains negative values.
 *
 * @param {Array<Number>} allValues Numeric array.
 * @return {Boolean} Boolean indicating if the array contains at least one negative value.
 */


var hasNegative = function hasNegative(allValues) {
  if (!allValues) return;
  return d3.min(allValues) < 0;
};
/**
 * Return a new array with absolute numbers.
 * @param {Array<Number>} allValues Input array of numbers.
 */


var getAllPositives = function getAllPositives(allValues) {
  return allValues.map(function (val) {
    return Math.abs(val);
  });
};
/**
 * Removes duplicates from an array.
 *
 * @export
 * @param {Array} array Source array.
 * @returns {Array} Array without duplicates.
 */


var removeDuplicates = function removeDuplicates(array) {
  if (!array) return;
  return array.filter(function (elem, index, _this) {
    return index === _this.indexOf(elem);
  });
};

var indexOf = function indexOf(array, property, search) {
  var i, len;

  for (i = 0, len = array.length; i < len; i++) {
    if (array[i][property] === search) return i;
  }

  return -1;
};
/**
 * Returns and array with all values stacked by index, it includes negative and positive values
 * @param {Array} arrays Array of arrays containing series values.
 * @return {Array} Array with all values.
 */


var getStackedValues = function getStackedValues(arrays) {
  var i = 0;
  var j = 0;
  var arrLength = arrays.length;
  var length = -1;
  var positive = 0;
  var negative = 0;
  var stacked = [];
  var actualLength, value; // Check array lengths

  for (; i < arrLength; i++) {
    actualLength = arrays[i].length;

    if (length !== -1 && actualLength !== length) {
      throw new Error("Arrays must have the same length");
    }

    length = actualLength;
  }

  i = 0;

  for (; i < length; i++) {
    for (; j < arrLength; j++) {
      value = arrays[j][i];

      if (value >= 0) {
        positive += value;
      } else {
        negative += value;
      }
    }

    stacked.push(Math.round(positive));
    if (negative !== 0) stacked.push(Math.round(negative));
    positive = 0;
    negative = 0;
    j = 0;
  }

  return stacked;
};
/**
 * It searches for the min and max value inside an array.
 *
 * @param {any} array
 * @param {any} accessor
 * @returns Object
 */


function minmax(array, accessor) {
  var len = array.length;
  var i = 0;
  var obj, value, min, max, minValue, maxValue;

  for (; i < len; i++) {
    obj = array[i];
    value = extract(obj, accessor);

    if (typeof minValue === "undefined" || value < minValue) {
      minValue = value;
      min = array[i];
    }

    if (typeof maxValue === "undefined" || value > maxValue) {
      maxValue = value;
      max = array[i];
    }
  }

  return {
    min: min,
    max: max
  };
}
/**
 * It returns the thousandths, hundredths, tenths, hundred, thousands to round the domain.
 *
 * @param {Number[]} array Array of numbers.
 * @return {Number} 0.001, 0.01, 0.1, 1, 10, 100, 1000, ...
 */


function getRoundToUnits(array) {
  if (!array || !array.length) return 1;
  var absMean = d3.mean(array, function (d) {
    return Math.abs(d);
  });
  if (absMean === 0) return 1;

  if (absMean >= 1) {
    absMean = Math.ceil(absMean / 10);
    return Math.pow(10, ("" + absMean).length);
  } else {
    var decimals = ("" + absMean).split(".")[1];
    var match = decimals.match(/[^0]/);
    return 1 / Math.pow(10, match.index + 1);
  }
}

module.exports = {
  getAllPositives: getAllPositives,
  getRoundToUnits: getRoundToUnits,
  getStackedValues: getStackedValues,
  hasNegative: hasNegative,
  hasNulls: hasNulls,
  indexOf: indexOf,
  minmax: minmax,
  removeDuplicates: removeDuplicates
};

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(12);
var fixRegExpWellKnownSymbolLogic = __webpack_require__(104);
var anObject = __webpack_require__(8);
var toLength = __webpack_require__(61);
var toString = __webpack_require__(30);
var requireObjectCoercible = __webpack_require__(21);
var getMethod = __webpack_require__(60);
var advanceStringIndex = __webpack_require__(105);
var regExpExec = __webpack_require__(106);

// @@match logic
fixRegExpWellKnownSymbolLogic('match', function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = regexp == undefined ? undefined : getMethod(regexp, MATCH);
      return matcher ? call(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (string) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(nativeMatch, rx, S);

      if (res.done) return res.value;

      if (!rx.global) return regExpExec(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = toString(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports = {"constants":{"color":{"white":"#ffffff","black":"#000000","neutral":{"12":"#1e1e1e","20":"#333333","37":"#5e5e5e","50":"#808080","67":"#ababab","80":"#cccccc","90":"#e5e5e5","95":"#f2f2f2"},"blue":{"23":"#004376","32":"#005ba1","36":"#006fba","38":"#1f55a5","41":"#0077cf","44":"#008dde"},"green":{"34":"#00af41"},"dark-green":{"34":"#518428"},"teal":{"19":"#005f5f"},"violet":{"46":"#6a4c9e"},"cyan":{"44":"#00a8e1"},"maroon":{"32":"#a50032"},"red":{"50":"#ff0000"},"yellow":{"48":"#f5c400"},"orange":{"54":"#ef7622"},"light-red":{"46":"#e60546"},"dark-violet":{"32":"#7d256f"},"dark-yellow":{"47":"#c19c31"},"aqua":{"37":"#00beaf"},"bright-orange":{"50":"#ff3c00"},"light-green":{"50":"#89bd40"}},"brand":{"blue":"#1f55a5","cyan":"#00a8e1"},"background-color":{"default":"#ffffff","light":"#f2f2f2","dark":"#1e1e1e","black":"#000000","alternative-row":{"default":"#e5e5e5","on-light":"#e5e5e5","on-dark":"#333333"},"feedback":{"error":"#ff0000","warning":"#f5c400"}},"text-color":{"primary":{"default":"#1e1e1e","on-light":"#1e1e1e","on-dark":"#ffffff"},"secondary":{"default":"#5e5e5e","on-light":"#5e5e5e","on-dark":"#ababab"},"link":{"default":"#006fba","on-light":"#006fba","on-dark":"#008dde"},"error":{"default":"#ff0000","on-light":"#ff0000","on-dark":"#ff0000"}},"interactive-color":{"primary":{"default":"#0077cf","hover":"#005ba1","focus":"#005ba1","active":"#004376"},"secondary":{"primary":"transparent","hover":"#5e5e5e","focus":"#5e5e5e","active":{"on-light":"#333333","on-dark":"#e5e5e5"}},"disabled":{"on-light":"#808080","on-dark":"#ababab"}},"visualization-color":{"asset-allocation":{"local-stocks":"#1f55a5","non-local-stocks":"#8faad2","stocks":"#1f55a5","real-estate":"#a50032","other":"#f5c400","cash":"#518428","bonds":"#ef7622","not-classified":"#e5e5e5"},"correlation":{"positive":"#1f55a5","negative":"#ef7622"},"sector":{"cyclical":"#ef7622","sensitive":"#1f55a5","defensive":"#518428"},"sustainability":"#1f55a5","valuation":{"under":"#00a8e1","fair":"#e5efef","over":"#ef7622"},"performance":{"positive":"#00af41","neutral-text":"#5e5e5e","neutral-chart":"#cccccc","negative":"#ff0000"}},"chart-color":{"1":"#1f55a5","2":"#a50032","3":"#f5c400","4":"#518428","5":"#00a8e1","6":"#6a4c9e","7":"#ef7622","8":"#005f5f","9":"#00af41","10":"#e60546","11":"#7d256f","12":"#c19c31","13":"#00beaf","14":"#ff3c00","15":"#89bd40"},"feedback-color":{"info":"#f2f2f2","error":"#ff0000","error-background":"#ffe5e5","warning":"#f5c400","warning-background":"#fef9e5","success":"#00af41","success-background":"#e5f7eb"},"font":{"family":{"sans-serif":"'Univers', HelveticaNeue, 'Helvetica Neue', Helvetica, Arial, sans-serif","monospace":"'Lucida Sans Typewriter', 'Lucida Console', monaco, 'Bitstream Vera Sans Mono', monospace"},"weight":{"thin":200,"light":300,"regular":400,"bold":600},"size":{"xs":"10px","s":"14px","m":"16px","l":"20px","base":"16px","default":"16px","heading-level-1":"45px","heading-level-2":"32px","heading-level-3":"28px","heading-level-4":"23px","heading-level-5":"20px","heading-level-6":"18px","code":"12px"},"line-height":{"headings":1.2,"body":1.375}},"border":{"separator":{"default":"solid 1px #e5e5e5","on-light":"solid 1px #cccccc","on-dark":"solid 1px #333333","on-title":"solid 2px #333333","color-on-light":"#cccccc","color-on-dark":"#333333"},"control":{"default":"solid 1px #808080","color":"#808080"},"container":{"default":"solid 1px #e5e5e5","color-default":"#e5e5e5"},"disabled":"solid 1px #808080","radius":{"panel":"12px","pill":"24px","round":"50%","s":"2px"}},"size":{"icon":{"s":"15px","m":"23px"}},"space":{"xs":"4px","s":"6px","m":"8px","l":"12px","xl":"16px","quarter-x":"2px","half-x":"4px","three-quarter-x":"6px","1-x":"8px","1-and-a-half-x":"12px","2-x":"16px","3-x":"24px","4-x":"32px","8-x":"64px","inset":{"xs":"4px","s":"6px","m":"8px","l":"12px","xl":"16px","quarter-x":"2px","half-x":"4px","three-quarter-x":"6px","1-x":"8px","1-and-a-half-x":"12px","2-x":"16px","3-x":"24px","4-x":"32px","8-x":"64px","stretch":{"s":"6px 12px","m":"8px 16px","l":"12px 24px"}},"inline-left":{"xs":"0 4px 0 0","s":"0 6px 0 0","m":"0 8px 0 0","l":"0 12px 0 0","xl":"0 16px 0 0","half-x":"0 4px 0 0","three-quarter-x":"0 6px 0 0","1-x":"0 8px 0 0","1-and-a-half-x":"0 12px 0 0","2-x":"0 16px 0 0"},"inline-right":{"xs":"0 0 0 4px","s":"0 0 0 6px","m":"0 0 0 8px","l":"0 0 0 12px","xl":"0 0 0 16px","half-x":"0 0 0 4px","three-quarter-x":"0 0 0 6px","1-x":"0 0 0 8px","1-and-a-half-x":"0 0 0 12px","2-x":"0 0 0 16px"},"stack":{"s":"0 0 6px","m":"0 0 8px","l":"0 0 12px","xl":"0 0 16px","quarter-x":"0 0 2px","half-x":"0 0 4px","three-quarter-x":"0 0 6px","1-x":"0 0 8px","1-and-a-half-x":"0 0 12px","2-x":"0 0 16px","3-x":"0 0 24px","4-x":"0 0 32px","8-x":"0 0 64px"}},"transition":{"color":{"link":"color, 300ms"}},"opacity":{"disabled":".4","overlay":".5"},"box-shadow":{"drop":"0 2px 4px 0 rgba(0, 0, 0, .08)","focus":"0 0 4px 2px rgba(#0077cf, .8)"},"z-index":{"low":1,"sticky":100,"modal-overlay":800,"modal-content":810,"top-of-the-world":900},"breakpoint":{"navigation":{"on-canvas-nav":"768px","wide":"1024px"}},"masthead":{"height":"50px","height-tall":"70px"},"site-navigation":{"height":"50px","vertical-width":"230px"}},"shared":[{"utils":true},{"color":true},{"fonts":true},{"accessibility":true},{"animation":true},{"size":true},{"bubbles":true},{"typography":true}],"components":[{"link":true},{"icon":true},{"button":true},{"button_group":true},{"card":true},{"navigation_container":true},{"container":true},{"data_table":true},{"dialog":true},{"form":true},{"combo_box":true},{"list_group":true},{"loader":true},{"modal":true},{"menu":true},{"notification":true},{"pagination":true},{"page_shell":true},{"popover":true},{"range_slider":true},{"search_field":true},{"stepper":true},{"switch":true},{"tag":true},{"tooltip":true},{"masthead":true},{"site_navigation":true},{"alert":true},{"top_hat":true},{"layout_grid":true}],"theme":"mds"}

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(49);

__webpack_require__(65);

__webpack_require__(81);

__webpack_require__(97);

__webpack_require__(116);

__webpack_require__(40);

__webpack_require__(101);

__webpack_require__(96);

__webpack_require__(113);

__webpack_require__(84);

var Utils = __webpack_require__(129);
/**
 * Creates a new DataManager instance.
 * @example
 * var dataManager = new DataManager();
 * @constructor
 */


function DataManager() {
  /**
   * @type {Array}
   * @private
   */
  this._data = [];
  /**
   * @type {Object}
   * @private
   */

  this._parsers = {};
  /**
   * @type {Number} Integer that holds the next index to assign
   * @private
   */

  this._nextIndex = 0;
}
/**
 * Gets all series attributes as parameters and returns a series object. This is intended to mantain legacy with previos versions.
 *
 * @param {String} seriesName Identifier for the series. Required.
 * @param {Array} series Array containing the series values. Required.
 * @param {String} groupName Identifier used to group series.
 * @param {Boolean} notIndexable If it is true the series is not indexed into the data manager.
 * @param {String} displayName String to be displayed.
 * @param {String} color String used for color of the data point.
 * @returns {Object} Series object
 */


function getSetAttributes(args) {
  var seriesName, series, groupName, notIndexable, displayName, color;
  seriesName = args[0];
  series = args[1];
  groupName = args[2];
  notIndexable = args[3];
  displayName = args[4];
  color = args[5];

  if (!seriesName || !series) {
    return;
  }

  return {
    name: seriesName,
    series: series,
    group: groupName,
    notIndexable: notIndexable,
    display: displayName,
    color: color
  };
}
/**
 * Recalculate indexed series indexes.
 *
 * @param {Array} data Array of series object.
 */


function recalcIndexes(data) {
  data.forEach(function (dataItem, i) {
    if (dataItem.index !== -1) {
      dataItem.index = i;
    }
  });
}
/**
 * Recalculate in-group indexes.
 *
 * @param {any} groupArray
 */


function recalcGroupIndexes(groupArray) {
  groupArray.forEach(function (item, i) {
    item.groupIndex = i;
  });
}
/**
 * Adds a series to the data manager. Receives an <i>Options Object</i> this way:
 * <br><br>
 * <code>
 * {
 *   name: "green_apples" // String
 *   series: [10, 20, 30, 40], // Array
 *   group: "Fruits",
 *   display: "Green Apples",
 *   notIndexable: false,
 *   color: "red"
 * }
 * </code>
 * <br>The <b>name</b> is the identifier for each series.
 * <br>The <b>series</b> Array is not necessary an array of number, it can be an array of objects with data.
 * <br><b>group</b> identifier is for data aggrupation if is not passed then <i>name</i> is used as group.
 * <br><b>display</b> is the text to show. If not passed then <i>name</i> is used as display name.
 * <br>If <b>notIndexable</b> is false, then the series is being indexed, non indexed series has index equals to -1.
 * <br><br>
 * For each series the datamanager creates a <i>Series Object</i> like:
 * <code>
 * {
 *   name: "green_apples",
 *   series: [10, 20, 30, 40],
 *   groupName: "Fruits",
 *   displayName: "Green Apples",
 *   index: 0,
 *   groupIndex: 0,
 *   color: "red"
 * }
 * </code>
 * @example
 * var dataManager = new DataManager();
 * // Minimal
 * dataManager.set({
 *   name: "Bar Chart Data",
 *   series: [40, 50, 60, 25]
 * });
 *
 * // If you need grouped data for a grouped bar chart for example.
 *
 * dataManager.set(
 *   name: "apples",
 *   display: "Apples",
 *   series: [25, 45, 43, 20],
 *   group: "grouped-bar-chart-data"
 * });
 *
 * dataManager.set({
 *   name: "oranges",
 *   display: "Oranges",
 *   series: [5, 20, 16, 27],
 *   group: "grouped-bar-chart-data"
 * });
 *
 * @param {Object} options Set of options.
 */


DataManager.prototype.set = function (options) {
  var groupName, groupIndex;

  if (!options) {
    return;
  } // For legacy purposes.


  if (typeof options === "string") {
    options = getSetAttributes(arguments);

    if (typeof options === "undefined") {
      return;
    }
  }

  groupName = options.group || options.name;
  groupIndex = this.queryGroup(groupName).length;

  this._data.push({
    name: options.name,
    series: options.series,
    groupName: groupName,
    displayName: options.display || options.name,
    index: !options.notIndexable || options.includeIndex ? this._nextIndex++ : -1,
    groupIndex: groupIndex,
    color: options.color,
    lineStrokeWidth: options.lineStrokeWidth
  });
};
/**
 * Unindexed Set, Same of set method but without set index to data, assing index = -1
 * Adds an unindexed series to the data manager. Receives an <i>Options Object</i> this way:
 * <br><br>
 * <code>
 * {
 *   name: "green_apples" // String
 *   series: [10, 20, 30, 40], // Array
 *   group: "Fruits",
 *   display: "Green Apples",
 * }
 * </code>
 * <br>The <b>name</b> is the identifier for each series.
 * <br>The <b>series</b> Array is not necessary an array of number, it can be an array of objects with data.
 * <br><b>group</b> identifier is for data aggrupation if is not passed then <i>name</i> is used as group.
 * <br><b>display</b> is the text to show. If not passed then <i>name</i> is used as display name.
 * @see set
 * @param {Object} options Set of options.
 */


DataManager.prototype.uset = function (options) {
  if (typeof options === "string") {
    options = getSetAttributes(arguments);

    if (typeof options === "undefined") {
      return;
    }
  }

  options.notIndexable = true;
  this.set(options);
};
/**
 * Update the series data specified by <i>seriesName</i>.
 * @example
 * dataManager.update("Apples", [2, 4, 6, 8]);
 * @param {String} seriesName Name of the series to update.
 * @param {Array} series Array of data to update.
 */


DataManager.prototype.update = function (seriesName, series) {
  var query = this._data.filter(function (series) {
    return series.name === seriesName;
  });

  var item;

  if (query.length) {
    item = query[0];
    item.series = series;
  }
};
/**
 * Removes a series from the data manager based on the series name.
 *
 * @param {String} seriesName Identifier of the series to remove.
 *
 * @return {Object} Removed Series Object.
 */


DataManager.prototype.remove = function (seriesName) {
  var index = Utils.array.indexOf(this._data, "name", seriesName);
  this._nextIndex = 0;
  var removed;

  if (index !== -1) {
    removed = this._data.splice(index, 1); // Recalculate general indexes

    recalcIndexes(this._data); // Recalculate group indexes

    recalcGroupIndexes(this.queryGroup(removed[0].groupName));
  }

  return removed;
};
/**
 * Resets the Datamanager.
 */


DataManager.prototype.clean = function () {
  this._data = [];
  this._parsers = {};
  this._nextIndex = 0;
};
/**
 * Search for the series in a determined group.
 *
 * @param {String} groupName Name of the group to search.
 * @returns {Array<Object>} Series in the group
 */


DataManager.prototype.queryGroup = function (groupName) {
  return this._data.filter(function (series) {
    return series.groupName === groupName;
  });
};
/**
 * If no parser is setted for the group then returns the raw data array from the store.
 * <br><br>
 * If parser is setted, then returns the data parsed by the function.
 *
 * @example
 * function parser(data, domain) {
 *   // data contains an array of series objects {}
 *   // domain is an argument
 *   var map = domain.map(function (point, i) {
 *       var obj = { point: point };
 *
 *       obj.values = data.map(function (value) {
 *           return {
 *               series: value.name,
 *               value: value.series[i]
 *           };
 *       });
 *       return obj;
 *   });
 *   return map;
 * }
 *
 * dataManager.parser("grouped-bar-chart-data", parser, ["Mon", "Tue", "Wed", "Thu"]);
 * var data = dataManager.get("grouped-bar-chart-data";
 * //  Resultingdata:
 * //  [{
 * //      point: "Mon",
 * //      values: {[
 * //          series: "Apples",
 * //          value: 25
 * //      ],[
 * //          series: "Oranges",
 * //          value: 5
 * //      ]...}
 * //  } ...]
 *
 * @param {any} groupName
 * @returns {Array} Array that contains data.
 */


DataManager.prototype.get = function (groupName) {
  if (!groupName) {
    return;
  }

  var data = this.queryGroup(groupName);
  var parser = this._parsers[groupName];
  var args;

  if (!parser) {
    return data;
  } else {
    args = [data].concat(parser.arguments);
    return parser.fn.apply(this, args);
  }
};
/**
 * Calculates the domain for the groups in _groupArray_, if not _groupArray_ is specified calculates for all data in the store.
 * <br><br>
 * Also rounds the domains to the nearest tenth (by default) or by the value specified in _roundDomainTo_.
 * @example
 * // There are 3 data groups: datagroup-1, datagroup-2 and datagroup-3.
 *
 * // Calculates domain only for groups datagroup-1 and datagroup-3.
 * var domain = dataManager.calculateDomain({
 *    groups: ["datagroup-1", "datagroup-2"]
 * });
 *
 * // Calculates domain for all groups.
 * var domain = dataManager.calculateDomain();
 *
 * // Calculates domain for all groups and round it to hundreds.
 * var domain = dataManager.calculateDomain({
 *  roundTo: 100
 *});
 *
 * // Calculates domain only for datagroup-3 and round it to hundreds.
 * var domain = dataManager.calculateDomain({
 *   groups: ["datagroup-3"],
 *   roundTo: 1000
 * });
 * @param {Object}? options Options available:
 * <li><b>groups:</b> Optional. Array of names of the data groups to include in the domain calculation.
 * <li><b>roundTo:</b> Optional. roundTo 10, 100, 1000, etc.
 * <li><b>forceNegative:</b> Optional. Boolean value to force negative values on the domain
 * <li><b>symmetrical:</b> Optional.
 * <li><b>steps:</b> Optional. Intended ticks number.
 * <li><b>accessor:</b> Optional. To access data.
 * <li><b>raw:</b> Optional. Force the domain calculation using unrounded values.
 *
 * @returns {Array} An array of length 2 with the calculated domain
 */


DataManager.prototype.calculateDomain = function (options) {
  options = options || {};

  var _this = this;

  var values = [];
  var groupArray = options.groups;
  var domainOptions = {
    forceNegative: options.forceNegative,
    symmetrical: options.symmetrical,
    steps: options.steps,
    integers: options.integers,
    raw: options.raw
  }; // If not defined get all groups

  if (!groupArray) {
    groupArray = Utils.array.removeDuplicates(this._data.map(function (data) {
      return data.groupName;
    }));
  }

  groupArray.forEach(function (group) {
    var query = _this.queryGroup(group);

    var series;

    var accessorMap = function accessorMap(item, accessor) {
      return item.series.map(function (d) {
        return Utils.object.extract(d, accessor);
      });
    };

    if (options.stacked) {
      series = query.map(function (item) {
        if (options.accessor) {
          return accessorMap(item, options.accessor);
        } else {
          return item.series;
        }
      });
      values = values.concat(Utils.array.getStackedValues(series));
    } else {
      query.forEach(function (item) {
        if (options.accessor) {
          values = values.concat(accessorMap(item, options.accessor));
        } else {
          values = values.concat(item.series);
        }
      });
    }
  }); // check values

  values = values.map(function (value) {
    return typeof value !== "undefined" ? value : 0;
  });
  var min = d3.min(values);
  var max = d3.max(values);
  var highest;
  var forceNegative = options.forceNegative;

  if (min === 0 && max === 0) {
    return forceNegative ? [-1, 1] : [0, 1];
  }

  if (max % 10 === 0) {
    values.push(max + 10);
  }

  if (min < 0 && min % 10 === 0) {
    values.push(min - 10);
  }

  if (typeof options.roundTo === "number") {
    domainOptions.roundTo = options.roundTo;
  } else if (min > -1 && max < 1) {
    return min < 0 || forceNegative ? [-1, 1] : [0, 1];
  } else if (max < 10 && min > -10) {
    highest = Math.max(Math.abs(min), Math.abs(max));
    domainOptions.roundTo = highest % 2 === 0 ? highest % 6 === 0 ? 4 : 3 : 2;
  } else {
    domainOptions.roundTo = Utils.array.getRoundToUnits(values);
  }

  domainOptions.values = values;
  return Utils.chart.getDomain(domainOptions);
};
/**
 * Sets a parser (formatter) function for a determined group of data. If arguments are passed they are passed too to the parser function as parameters.
 *
 * @param {any} groupName
 * @param {any} parser
 * @returns {Function} If only one argument is passed
 */


DataManager.prototype.parser = function (groupName, parser) {
  var newParser;

  if (!groupName) {
    return;
  }

  if (!parser) {
    return this._parsers[groupName];
  }

  newParser = {};
  newParser.fn = parser;
  newParser.arguments = Array.prototype.slice.call(arguments, 2);
  this._parsers[groupName] = newParser;
  return parser;
};
/**
 * Returns all data combined
 * @example
 *  dataManager.set("Cars", [10, 20], "vehicles");
 *  dataManager.set("Planes", [30, 40], "vehicles");
 *  dataManager.set("Tricycle", [5, 15], "tricycle");
 *
 *  dataManager.combine("tricycle")
 *  dataManager.combine(["vehicles", "tricycle"])
 *
 * @param {Array|String} groupNames The name of a group name or an array containing all group names you want to get data combined.
 * @return {Array} Data combined.
 */


DataManager.prototype.combine = function (groupNames) {
  var metadataArray = [];
  var seriesArray = [];
  var combined = [];
  var i = 0;
  var j = 0;
  var len, pointObj, seriesLength, metadata, value;
  groupNames = typeof groupNames === "string" ? [groupNames] : groupNames;
  groupNames.forEach(function (seriesObject) {
    this.queryGroup(seriesObject).forEach(function (point) {
      seriesArray.push(point.series);
      metadataArray.push({
        name: point.name,
        groupName: point.groupName,
        displayName: point.displayName,
        index: point.index,
        groupIndex: point.groupIndex,
        color: point.color
      });
    });
  }.bind(this));
  len = seriesArray[0].length;
  seriesLength = seriesArray.length;

  for (; i < len; i++) {
    pointObj = [];
    j = 0;

    for (; j < seriesLength; j++) {
      value = seriesArray[j][i];
      metadata = metadataArray[j];
      pointObj.push({
        name: metadata.name,
        groupName: metadata.groupName,
        displayName: metadata.displayName,
        index: metadata.index,
        value: value,
        groupIndex: metadata.groupIndex,
        color: metadata.color
      });
    }

    combined.push(pointObj);
  }

  return combined;
};
/**
 * Returns <b>true</b> if a series is contained in a give group.
 * @param {String} seriesName
 * @param {String} groupName
 * @returns {Boolean}
 */


DataManager.prototype.inGroup = function (seriesName, groupName) {
  var group = this.queryGroup(groupName);
  var len = group.length;
  var i;

  for (i = 0; i < len; i++) {
    if (group[i].name === seriesName) {
      return true;
    }
  }

  return false;
};

module.exports = DataManager;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Creates a new ScaleManager instance.
 *
 * @constructor
 * @param {Object} scales
 */

function ScaleManager(scales) {
  this._scales = scales || {};
}
/**
 * Sets a new scale, if no <i>scale</i> is passed then returns the scale object.
 *
 * @param {String} scaleName Name for the scale.
 * @param {D3.scale} scale
 * @returns {D3.scale}
 */


ScaleManager.prototype.scale = function (scaleName, scale) {
  if (!scaleName) {
    return;
  }

  if (!scale) {
    return this._scales[scaleName];
  }

  this._scales[scaleName] = scale;
};
/**
 * Sets the scale's domain, if no <i>domain</i> is passed returns it.
 *
 * @param {String} scaleName
 * @param {Array} domain
 * @returns {Array} Domain for a specific scale.
 */


ScaleManager.prototype.domain = function (scaleName, domain) {
  if (!scaleName) {
    return;
  }

  if (!domain) {
    return this._scales[scaleName].domain();
  }

  this._scales[scaleName].domain(domain);
};
/**
 * Sets the scale's range, if no _range_ is passed returns it.
 *
 * @param {String} scaleName
 * @param {Array} range
 * @returns Range for a specific scale.
 */


ScaleManager.prototype.range = function (scaleName, range) {
  if (!scaleName) {
    return;
  }

  if (!range) {
    return this._scales[scaleName].range();
  }

  this._scales[scaleName].range(range);
};
/**
 * Remove a scale from the hashmap.
 * @param {String} scaleName Scale to remove.
 */


ScaleManager.prototype.remove = function (scaleName) {
  delete this._scales[scaleName];
};

module.exports = ScaleManager;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(161);


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(162);

var _core = _interopRequireDefault(__webpack_require__(152));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @module Core */
module.exports = _core.default;

/***/ }),
/* 162 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(11);
var fails = __webpack_require__(3);
var toIndexedObject = __webpack_require__(10);
var nativeGetOwnPropertyDescriptor = __webpack_require__(41).f;
var DESCRIPTORS = __webpack_require__(7);

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetOwnPropertyDescriptor(1); });
var FORCED = !DESCRIPTORS || FAILS_ON_PRIMITIVES;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(96);

__webpack_require__(49);

__webpack_require__(113);

var array = __webpack_require__(155);

var object = __webpack_require__(141);
/**
 * Calculate tickvalues for a given dataset.
 *
 * @param {Array} domain Two values array.
 * @param {Number} ticksNumber Number of ticks to show.
 *
 * @return {Array} Containing the ticks to include in the chart's axis.
 */


var getTickValues = function getTickValues(domain, ticksNumber) {
  ticksNumber = ticksNumber || 4;
  var distance = Math.abs(domain[0] - domain[1]);
  var domainStep = distance / ticksNumber;
  var min = domain[0];
  var max = domain[1];
  var tickValues = [];

  while (min < max) {
    tickValues.push(min);
    min += domainStep;
  }

  tickValues.push(min);
  return tickValues;
};

function ensureGreaterThanOne(num) {
  var power = 0;

  while (num < 10) {
    num = num * 10;
    power++;
  }

  return {
    number: num,
    power: power
  };
}
/**
 * Returns a domain with positive numbers starting from 0 based on the chart values.
 *
 * @param {Array} allValues Array of numbers containing values used to caculate the domain.
 * @param {Number} roundTo Tenths, hundreds, thousands,...
 * @param {boolean} integers Show only integer numbers, without decimal.
 * @param {Number} steps Numbers of intended steps into the domain.
 * @returns {Array} Two values array with the domain.
 */


function getPositiveDomain(allValues, roundTo, integers, steps) {
  var max = Math.ceil(d3.max(allValues) / roundTo) * roundTo;
  if (max === 0) return [0, 1];
  var ensured = ensureGreaterThanOne(max);
  var mod, power;
  var almostZero = 0.01;
  max = ensured.number;
  power = ensured.power;
  roundTo *= Math.pow(10, power);

  if (integers) {
    mod = max % steps;

    while (mod <= almostZero) {
      max += roundTo;
      mod = max % steps;
    }
  }

  max = max / Math.pow(10, power);
  return [0, max];
}
/**
 * Returns a Symmetrical domain based on the chart values.
 *
 * @param {Array} allValues Array of numbers containing values used to caculate the domain.
 * @param {Number} roundTo Tenths, hundreds, thousands,...
 * @returns
 */


function getSymmetricalDomain(allValues, roundTo, integers, steps) {
  var allPositive = array.getAllPositives(allValues);
  var max = Math.ceil(d3.max(allPositive) / roundTo) * roundTo;
  if (max === 0) return [-1, 1];
  var ensured = ensureGreaterThanOne(max);
  var min, mod, power;
  max = ensured.number;
  power = ensured.power;
  min = max * -1;
  roundTo *= Math.pow(10, power);

  if (integers) {
    mod = max * 2 % steps;

    while (mod !== 0) {
      max += roundTo;
      mod = max * 2 % steps;
    }

    min = max * -1;
  }

  min = min / Math.pow(10, power);
  max = max / Math.pow(10, power);
  return [min, max];
}
/**
 * Returns an Asymmetrical domain based on the chart values.
 *
 * @param {Array} allValues Array of numbers containing values used to caculate the domain.
 * @param {Number} roundTo Tenths, hundreds, thousands,...
 * @returns
 */


function getAsymmetricalDomain(allValues, roundTo) {
  var max = Math.ceil(d3.max(allValues) / roundTo) * roundTo;
  var min = Math.floor(d3.min(allValues) / roundTo) * roundTo;
  return [min, max];
}
/**
 * Calculates the domain for a certain dataset.
 *
 * @param {Object}? options Options available:
 * <li><b>values:</b> Required. Array of values.
 * <li><b>roundTo:</b> Optional. roundTo 10, 100, 1000, etc.
 * <li><b>forceNegative:</b> Optional. Boolean value to force negative values on the domain
 * <li><b>symmetrical:</b> Optional.
 * <li><b>steps:</b> Optional. Intended ticks number.
 *
 * @return {Array} Two values array indicating the domain.
 */


var getDomain = function getDomain(options) {
  options = options || {};
  var allValues = options.values;
  var roundTo = options.roundTo || 10;
  var integers = object.getBoolean(options.integers, false);
  var forceNegative = object.getBoolean(options.forceNegative, false);
  var symmetrical = object.getBoolean(options.symmetrical, true);
  var raw = object.getBoolean(options.raw, false);
  var steps = options.steps || 4;
  var negatives;

  if (!allValues || allValues.length === 0) {
    return [0, 1];
  }

  negatives = array.hasNegative(allValues);
  allValues = array.removeDuplicates(allValues);

  if (raw) {
    return [d3.min(allValues), d3.max(allValues)];
  }

  if (!negatives && !forceNegative) {
    return getPositiveDomain(allValues, roundTo, integers, steps);
  } else if (symmetrical) {
    return getSymmetricalDomain(allValues, roundTo, integers, steps);
  } else {
    return getAsymmetricalDomain(allValues, roundTo, integers, steps);
  }
};
/**
 * Returns the index of a given value into a range array.
 * @param {Number} val Value to find index into range array.
 * @param {Array<Array>} range Range array. ex: [[-infinity, -1], [-1, 0], [0, 1], [1, Infinity]]
 * @return {Number} The range index or -1.
 */


function getRangeIndex(val, range) {
  for (var i = 0; i < range.length; i++) {
    if (val > range[i][0] && (val <= range[i][1] || range[i][1] === undefined)) {
      return i;
    }
  }

  return -1;
}
/**
 * Returns the value of a given value into a values array.
 * @param {Number} val Value to find index into range array.
 * @param {Array<Array>} range Range array. ex: [[-infinity, -1], [-1, 0], [0, 1], [1, Infinity]]
 * @param {Array} values Values to return
 * @return {Object} The value that matches range index or `undefined`.
 */


function getRangeValue(val, range, values) {
  var index = getRangeIndex(val, range);
  if (index !== -1) return values[index];
}
/**
 * Returns the calculated padding between bars
 * @param {Array} num the number of bars
 * @param {Number} dim the height or width of the canvas
 * @param {String} orient whether horizontal or vertical bar chart
 * @return {String} type whether standard or grouped bars
 */


function getBarPadding(num, dim, orient) {
  var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "standard";
  var padding = 9;
  var ratio = dim / num;

  if (orient === "horizontal" || orient === "vertical" && type === "standard") {
    if (ratio > 21) {
      return padding;
    } else if (ratio <= 21 && ratio > 14) {
      padding = 6;
    } else if (ratio <= 14 && ratio > 7) {
      padding = 3;
    } else {
      padding = 1;
    }
  } else if (orient === "vertical" && type === "grouped") {
    if (ratio > 16.5) {
      return padding;
    } else if (ratio <= 16.5 && ratio > 11) {
      padding = 6;
    } else if (ratio <= 11 && ratio > 5.5) {
      padding = 3;
    } else {
      padding = 1;
    }
  }

  return padding;
}

module.exports = {
  getTickValues: getTickValues,
  getDomain: getDomain,
  getRangeIndex: getRangeIndex,
  getRangeValue: getRangeValue,
  getBarPadding: getBarPadding
};

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Calls a function if exists. The first argument should be the function to call followed by the arguments.
 *
 * @return {Object} Undefined if there is no function to call or what the function returns.
 */

__webpack_require__(84);

var callFn = function callFn() {
  var args = Array.prototype.slice.call(arguments, 2);
  var context = arguments[0];
  var fn = arguments[1];

  if (fn) {
    return fn.apply(context, args);
  }
};

module.exports = {
  call: callFn
};

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(49);

__webpack_require__(114);

__webpack_require__(84);

__webpack_require__(89);

__webpack_require__(145);

__webpack_require__(156);

__webpack_require__(40);

__webpack_require__(65);

__webpack_require__(147);

__webpack_require__(116);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CARDINAL_STR = "$$";
/**
 * Adjusts display of missing values and negative values.
 * Returns original value if zero or positive number
 * Returns emdash (U2014) if NaN
 * Returns value with dash replaced by endash(U2013) if negative
 *
 * @param {Number} A single number.
 * @return {Number || String} 10, "—10", "NaN", ...
 */

function convertDashToEnDash(val) {
  var stringed = val.toString();

  if (stringed === "NaN") {
    return "\u2014";
  }

  if (stringed[0] === "-") {
    var sliced = stringed.slice(1);
    sliced = "\u2013" + sliced;
    return sliced;
  }

  return val;
}
/**
 * Generates a Unique ID.
 * @returns {String} New unique ID.
 */


var UID = function UID() {
  return "_" + (Date.now().toString(36) + Math.random().toString(36).substr(2, 5));
};
/**
 * Converts a string in dashed format.
 *
 * @param {String} str String to convert.
 * @returns {String}
 */


function dashify(str) {
  str = str.replace(/\s+/g, "-").toLowerCase();
  return str;
}
/**
 * Compiles a string template against a context and returns a new string.
 * <code>
 * var template =
 * 'My skills:' +
 * '<%if(this.showSkills) {%>' +
 *    '<%for(var index in this.skills) {%>' +
 *    '<a href="#"><%this.skills[index]%></a>' +
 *   '<%}%>' +
 * '<%} else {%>' +
 *    '<p>none</p>' +
 * '<%}%>';
 * console.log(TemplateEngine(template, {
 *    skills: ["js", "html", "css"],
 *    showSkills: true
 * }));
 * </code>
 * @param {String} html Template string.
 * @param {Object} data Context object that contains the data.
 * @returns {String}
 */


var template = function template(html, data) {
  var re = /<%([^%>]+)?%>/g;
  var reExp = /(^( )?(if|for|else|switch|case|break|{|}))(.*)?/g;
  var code = "var r=[];\n";
  var cursor = 0;
  var match;

  var add = function add(line, js) {
    js ? code += line.match(reExp) ? line + "\n" : "r.push(" + line + ");\n" : code += line !== "" ? "r.push('" + line.replace(/"/g, "\\'") + "');\n" : ""; //jshint ignore:line

    return add;
  };

  match = re.exec(html);

  while (match) {
    add(html.slice(cursor, match.index))(match[1], true);
    cursor = match.index + match[0].length;
    match = re.exec(html);
  }

  add(html.substr(cursor, html.length - cursor));
  code += "return r.join('');";
  return new Function(code.replace(/[\r\t\n]/g, "")).apply(data); // jshint ignore:line
};
/**
 * Adds a prefix based on an index.
 *
 * @param {String} str
 * @param {Number} index
 * @returns {String}
 */


function mask(str, index) {
  return index + CARDINAL_STR + str;
}
/**
 * Remove index based prefix.
 *
 * @param {String} str
 * @returns {String}
 */


function unmask(str) {
  if (!str) return '';
  var index = str.indexOf(CARDINAL_STR);
  return index < 0 ? str : str.substr(index + CARDINAL_STR.length);
}
/**
 * Get pixel with of string appended to the DOM
 *
 * @param {String} txt
 * @param {String} fontname = font family, e.g., "'UniversBold', 'HelveticaNeue-Bold', 'Helvetica Neue Bold', Helvetica, Arial, sans-serif"
 * @param {Number} fontsize, e.g., 16px
 * @returns {String}
 */


function getTextWidth(txt, fontname, fontsize) {
  var canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement("canvas"));
  var context = canvas.getContext("2d");
  context.font = "".concat(fontsize, " ").concat(fontname);
  var w = context.measureText(txt);
  canvas = null;
  return w.width;
}
/**
 * To get the pixel width of the longest string in the data set
 *
 * @param {String} txt
 * @param {String} fontname = font family, e.g., "'UniversBold', 'HelveticaNeue-Bold', 'Helvetica Neue Bold', Helvetica, Arial, sans-serif"
 * @param {Number} fontsize, e.g., 16
 * @returns {String}
 */


function getLongestTextStringWidth(data, font, size) {
  font = font || "'UniversBold', 'HelveticaNeue-Bold', 'Helvetica Neue Bold', Helvetica, Arial, sans-serif";
  size = size || 16;
  var longest = 0;
  var value;
  data.forEach(function (obj) {
    if (obj.value != null && obj.value.toString().length > longest) {
      longest = obj.value.toString().length;
      value = obj.value;
    }
  });
  var w = getTextWidth(value, font, size);
  return w;
}
/**
 * Break strings to fit a specific width when no natural breakpoints are available
 *
 * @param {String} text string that needs to be broken
 * @param {Number} textWidth calculated DOM width of that string
 * @param {Number} containerWidth width the string cannot exceed.
 * @param {Boolean} isStyleMap specifies if the chart type is Style Map
 * @returns {Array}
 */


function breakString(text, textWidth, containerWidth) {
  var isStyleMap = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var acceptableStringLength = Math.round(text.length * containerWidth / textWidth);
  var newStrings = text.match(new RegExp('.{1,' + acceptableStringLength + '}', 'g'));
  return this.checkSingleStrings(newStrings, isStyleMap);
}
/**
 * @param {string} character such as 'a', '-', '#'
 *
 * @returns {number} width of the character in 14px Univers
 */


function getCharacterWidth(character) {
  var _characterWidthMap;

  var characterWidthMap = (_characterWidthMap = {
    a: 6.14599609375,
    b: 6.467987060546875,
    c: 5.683990478515625,
    d: 6.467987060546875,
    e: 6.1039886474609375,
    f: 3.891998291015625,
    g: 6.48199462890625,
    h: 6.6079864501953125,
    i: 2.98199462890625,
    j: 2.98199462890625,
    k: 5.739990234375,
    l: 2.98199462890625,
    m: 9.64599609375,
    n: 6.6079864501953125,
    o: 6.2299957275390625,
    p: 6.467987060546875,
    q: 6.4539947509765625,
    r: 4.05999755859375,
    s: 5.36199951171875,
    t: 3.9059906005859375,
    u: 6.6079864501953125,
    v: 5.6139984130859375,
    w: 9.393997192382812,
    x: 5.4319915771484375,
    y: 5.62799072265625,
    z: 4.717987060546875,
    A: 7.6719970703125,
    B: 7.321990966796875,
    C: 7.15399169921875,
    D: 7.82598876953125,
    E: 6.3839874267578125,
    F: 5.85198974609375,
    G: 7.5879974365234375,
    H: 8.035995483398438,
    I: 3.42999267578125,
    J: 6.3839874267578125,
    K: 6.985992431640625,
    L: 5.7679901123046875,
    M: 11.017990112304688,
    N: 8.581985473632812,
    O: 7.7559967041015625,
    P: 6.7899932861328125,
    Q: 7.839996337890625,
    R: 7.33599853515625,
    S: 6.803985595703125,
    T: 6.0619964599609375,
    U: 8.035995483398438,
    V: 7.097991943359375,
    W: 11.605987548828125,
    X: 7,
    Y: 6.761993408203125,
    Z: 6.313995361328125,
    0: 6.3279876708984375,
    1: 6.3279876708984375,
    2: 6.3279876708984375,
    3: 6.3279876708984375,
    4: 6.3279876708984375,
    5: 6.3279876708984375,
    6: 6.3279876708984375,
    7: 6.3279876708984375,
    8: 6.3279876708984375,
    9: 6.3279876708984375,
    "‐": 8.1005859375,
    "-": 4.003997802734375,
    "–": 7,
    "—": 14.013992309570312,
    _: 7,
    "=": 7.545989990234375,
    "~": 7.545989990234375,
    "^": 8.301986694335938,
    "&": 7.881988525390625,
    "#": 6.3279876708984375,
    "@": 12.235992431640625,
    "(": 3.485992431640625,
    ")": 3.485992431640625,
    "*": 5.907989501953125,
    "[": 3.485992431640625,
    "]": 3.485992431640625
  }, _defineProperty(_characterWidthMap, "-", 4.003997802734375), _defineProperty(_characterWidthMap, "#", 6.3279876708984375), _characterWidthMap);

  if (character in characterWidthMap) {
    return characterWidthMap[character];
  }

  return getTextWidth(character, "Univers", "14px");
}
/**
 * @param {character} char1 such as 'a', '-', '#'
 * @param {character} char2 such as 'A', '-', '#'
 *
 * @returns {boolean} true if they are both letters and char1
 * is in lower case and char2 is in upper case, false otherwise
 */


function compareLetterCase(char1, char2) {
  var isLowerCaseRegex = /[a-z]/;
  var isUpperCaseRegex = /[A-Z]/;

  if (isLowerCaseRegex.test(char1) && isUpperCaseRegex.test(char2)) {
    return true;
  }

  return false;
}
/**
 * Break legend text to an array when the text cannot fit in the container
 *
 * Note:
 * 1. The logic factors in punctuation marks such as hyphen
 * 2. The logic factors in letter cases
 *
 * @example
 * "somePrefix-content" is broken into ["somePrefix-", "content"] instead of ["somePrefix-con", "tent"]
 * "MorningstarBaseCharts" is broken into ["Morningstar", "BaseCharts"] instead of ["MorningstarBa", "seCharts"]
 *
 * @param {String} text string that needs to be broken
 * @param {Number} containerWidth width the string cannot exceed excluding any icon paddings
 * @returns {Array} an array guaranteed to fit in the container
 */


function breakLegend(text, containerWidth) {
  var fragments = [];
  var runningText = "";
  var runningTextIndex = 0;
  var runningTextWidth = 0;
  var breakpointIndex = -1; // This could either be a punctuation mark or a different letter case

  var punctuationMarks = [" ", "‐", "-", "–", "—", "_", "=", "~", "^", "&", "#", "@", "(", ")", "*", "[", "]", "-", "#"]; // Add more punctuation marks if necessary

  for (var i = 0; i < text.length; i++) {
    var currChar = text[i];
    runningTextWidth += getCharacterWidth(currChar);

    if (runningTextWidth >= containerWidth) {
      // If we have seen a breakpoint, add the text up to the breakpoint; otherwise, add all running text
      if (breakpointIndex != -1) {
        fragments.push(runningText.slice(0, breakpointIndex));
        runningText = runningText.slice(breakpointIndex) + currChar;
        runningTextIndex = runningText.length;
        runningTextWidth = getTextWidth(runningText);
      } else {
        fragments.push(runningText);
        runningText = currChar;
        runningTextIndex = 1;
        runningTextWidth = getCharacterWidth(currChar);
      }

      breakpointIndex = -1;
      continue;
    }

    runningText += currChar;
    runningTextIndex += 1; // Mark the punctuation or the next character if the next character has a different letter case

    if (punctuationMarks.indexOf(currChar) >= 0) {
      breakpointIndex = runningTextIndex;
    } else if (i + 1 < text.length && compareLetterCase(currChar, text[i + 1])) {
      breakpointIndex = runningTextIndex;
    }
  }

  if (runningText !== "") {
    fragments.push(runningText);
  }

  return fragments;
}
/**
 * Concats strings that have been broken into some segments
 *
 * @example
 *  when isStypeMap is false:
 *  checkSingleStrings(['abc', 'd']) returns ['abcd']
 *  checkSingleStrings(['abc', 'de']) returns ['abc', 'de']
 *  checkSingleStrings(['abc', 'def']) returns ['abc', 'def']
 *
 *  when isStypeMap is true:
 *  checkSingleStrings(['abc', 'd']) returns ['abcd']
 *  checkSingleStrings(['abc', 'de']) returns ['abcde']
 *  checkSingleStrings(['abc', 'def']) returns ['abcdef']
 *
 * @param {Array} text string array that is broken
 * @param {Boolean} isStyleMap specifies if the chart type is Style Map
 * @returns {Array}
 **/


function checkSingleStrings(text, isStyleMap) {
  var maxLength = isStyleMap ? 3 : 1;

  for (var i = 0; i < text.length; i++) {
    var obj = text[i];

    if (obj.length <= maxLength) {
      // get index of current
      var indexOfWord = text.indexOf(obj); // set prev index to concat with current

      if (indexOfWord === 0) {
        if (text.length < maxLength) {
          text = text[indexOfWord].concat(text[indexOfWord + 1]);
          return [text];
        } else {
          break;
        }
      } else {
        text.splice(indexOfWord - 1, 2, text[indexOfWord - 1].concat(text[indexOfWord]));
      }
    }
  }

  return text;
}

module.exports = {
  convertDashToEnDash: convertDashToEnDash,
  dashify: dashify,
  template: template,
  UID: UID,
  mask: mask,
  unmask: unmask,
  getLongestTextStringWidth: getLongestTextStringWidth,
  getTextWidth: getTextWidth,
  breakString: breakString,
  checkSingleStrings: checkSingleStrings,
  breakLegend: breakLegend
};

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(49);

__webpack_require__(65);

__webpack_require__(81);

__webpack_require__(89);

var object = __webpack_require__(141);
/**
 * Returns the path for a rounded rectangle.
 * @param {Number} x X position.
 * @param {Number} y Y position.
 * @param {Number} w Width.
 * @param {Number} h Heigth.
 * @param {Number} r Radius.
 * @param {Boolean} tl Top-Left.
 * @param {Boolean} tr Top-Right.
 * @param {Boolean} bl Bottom-Left.
 * @param {Boolean} br Bottom-Right.
 * @returns {String} Rounded Rectangle path.
 */


var roundedRect = function roundedRect(x, y, w, h, r, tl, tr, bl, br) {
  var result;
  result = "M" + (x + r) + "," + y;
  result += "h" + (w - 2 * r);

  if (tr) {
    result += "a" + r + "," + r + " 0 0 1 " + r + "," + r;
  } else {
    result += "h" + r;
    result += "v" + r;
  }

  result += "v" + (h - 2 * r);

  if (br) {
    result += "a" + r + "," + r + " 0 0 1 " + -r + "," + r;
  } else {
    result += "v" + r;
    result += "h" + -r;
  }

  result += "h" + (2 * r - w);

  if (bl) {
    result += "a" + r + "," + r + " 0 0 1 " + -r + "," + -r;
  } else {
    result += "h" + -r;
    result += "v" + -r;
  }

  result += "v" + (2 * r - h);

  if (tl) {
    result += "a" + r + "," + r + " 0 0 1 " + r + "," + -r;
  } else {
    result += "v" + -r;
    result += "h" + r;
  }

  result += "z";
  return result;
};
/**
 * Get an SVG Text width by adding it, getting the width and removing it.
 * @param {D3.Object} svgContainer Container where the text is gonna be attached.
 * @param {String} text Text to test width.
 * @return {Number} Calculated width.
 */


var getSVGTextWidth = function getSVGTextWidth(svgContainer, text, className) {
  var el = svgContainer.append("text").classed(className, true && className).text(text);
  var width = el.node().getBoundingClientRect().width;
  el.remove();
  return width;
};
/**
 * Get the longest String in pixels from a given array of data.
 * @param {D3.Object} svgContainer Container where the texts are gonna be attached.
 * @param {Array} data Array containig the texts.
 * @param {String|Function}? accessor description
 */


var getGreaterSVGTextWidth = function getGreaterSVGTextWidth(svgContainer, data, accessor) {
  var greatest = 0;
  var text, width;
  data.forEach(function (item, i) {
    text = object.extract(item, accessor, i);
    width = getSVGTextWidth(svgContainer, text);
    greatest = width > greatest ? width : greatest;
  });
  return greatest;
};
/**
 * Get the total width of all Strings in pixels from a given array of data.
 * @param {D3.Object} svgContainer Container where the texts are gonna be attached.
 * @param {Array} data Array containig the texts.
 * @param {String|Function}? accessor description
 */


var getTotalSVGTextWidth = function getTotalSVGTextWidth(svgContainer, data, accessor) {
  var total = 0;
  var width;
  data.forEach(function (item, i) {
    var dataName = item.__data__.displayName || item.__data__.name;
    width = getSVGTextWidth(svgContainer, dataName) + 15;

    if (item instanceof SVGElement) {
      var isSafari = /^((?!chrome|android|crios|fxios).)*safari/i.test(navigator.userAgent);
      width = item.getBoundingClientRect().width > width && !isSafari ? item.getBoundingClientRect().width : width;
    }

    total += width;
  });
  return total;
};

module.exports = {
  roundedRect: roundedRect,
  getSVGTextWidth: getSVGTextWidth,
  getGreaterSVGTextWidth: getGreaterSVGTextWidth,
  getTotalSVGTextWidth: getTotalSVGTextWidth
};

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(49);

__webpack_require__(40);

var mbc_mds_constants = __webpack_require__(157).constants;

var mbc_mds_chart_color = mbc_mds_constants["chart-color"];
/**
 * deprecating `var colors` in v3.0.0
 */

var colors = {
  "blue": mbc_mds_chart_color["1"],
  "maroon": mbc_mds_chart_color["2"],
  "teal": mbc_mds_chart_color["8"],
  "orange": mbc_mds_chart_color["7"],
  "green": mbc_mds_chart_color["9"],
  "violet": mbc_mds_chart_color["6"],
  "yellow": mbc_mds_chart_color["3"],
  "cyan": mbc_mds_chart_color["5"],
  "dark-green": mbc_mds_chart_color["4"],
  "red": mbc_mds_constants["color"]["red"]["50"],
  "light-red": mbc_mds_chart_color["10"],
  "dark-violet": mbc_mds_chart_color["11"],
  "dark-yellow": mbc_mds_chart_color["12"],
  "aqua": mbc_mds_chart_color["13"],
  "bright-orange": mbc_mds_chart_color["14"],
  "light-green": mbc_mds_chart_color["15"],
  "white": mbc_mds_constants["color"].white,
  "grey1": mbc_mds_constants["color"]["neutral"]["90"],
  "grey2": mbc_mds_constants["background-color"].light,
  "grey3": mbc_mds_constants["color"]["neutral"]["80"],
  "grey4": mbc_mds_constants["color"]["neutral"]["80"],
  "grey5": mbc_mds_constants["color"]["neutral"]["50"],
  "grey6": mbc_mds_constants["color"]["neutral"]["37"],
  "grey7": mbc_mds_constants["color"]["neutral"]["12"],
  "black": mbc_mds_constants["color"].black
};
var primary = [mbc_mds_chart_color["1"], mbc_mds_chart_color["2"], mbc_mds_chart_color["3"], mbc_mds_chart_color["4"], mbc_mds_chart_color["5"], mbc_mds_chart_color["6"], mbc_mds_chart_color["7"], mbc_mds_chart_color["8"], mbc_mds_chart_color["9"]];
var secondary = [mbc_mds_chart_color["10"], mbc_mds_chart_color["11"], mbc_mds_chart_color["12"], mbc_mds_chart_color["13"], mbc_mds_chart_color["14"], mbc_mds_chart_color["15"]];
var palettes = [primary, secondary];
var combined = palettes.reduce(function (a, b) {
  return a.concat(b);
}, []);
module.exports = {
  colors: colors,
  primary: primary,
  secondary: secondary,
  combined: combined,
  mbc_mds_constants: mbc_mds_constants,
  mds_constants: mbc_mds_constants,
  mbc_mds_chart_color: mbc_mds_chart_color,
  mds_chart_color: mbc_mds_chart_color
};

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  /**
   * Returns how many digits have a number.
   * @param {number} number Number to inspect. Rquired.
   * @param {Number} base Numeric base.
   * @returns {Number}
   */
  digits: function digits(number) {
    var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
    var digits = 0;

    while (number >= 1) {
      number = number / base;
      digits++;
    }

    return digits;
  },

  /**
  * @method isNumber
  * @desc Judge if a value is a valid number or a valid string number
  * @param literals value
  * Return Boolean
  */
  isNumber: function isNumber(value) {
    if (typeof value === "number" && isFinite(value)) {
      return true;
    }

    if (typeof value === "string" && value !== "" && !isNaN(value - 0)) {
      return true;
    }

    return false;
  },

  /**
   * @method getValidValue
   * @desc Return value if it is included in the valid values array, return the default otherwise
   * @param {Number} value 
   * @param {Object} validValues array including valid values
   * @param {Number} defaultValue
   */
  getValidValue: function getValidValue(value, validValues, defaultValue) {
    if (validValues.length === 0 || validValues.indexOf(value) === -1) {
      return defaultValue;
    }

    return value;
  }
};

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(85);

__webpack_require__(84);

__webpack_require__(49);

__webpack_require__(114);

var crmatrix = __webpack_require__(171);
/**
 * @fileOverview Generates "Lorem ipsum" style text.
 * @author rviscomi@gmail.com Rick Viscomi,
 * 		tinsley@tinsology.net Mathew Tinsley
 * @version 1.0
 */

/**
 *	Copyright (c) 2009, Mathew Tinsley (tinsley@tinsology.net)
 *	All rights reserved.
 *
 *	Redistribution and use in source and binary forms, with or without
 *	modification, are permitted provided that the following conditions are met:
 *		* Redistributions of source code must retain the above copyright
 *		  notice, this list of conditions and the following disclaimer.
 *		* Redistributions in binary form must reproduce the above copyright
 *		  notice, this list of conditions and the following disclaimer in the
 *		  documentation and/or other materials provided with the distribution.
 *		* Neither the name of the organization nor the
 *		  names of its contributors may be used to endorse or promote products
 *		  derived from this software without specific prior written permission.
 *
 *	THIS SOFTWARE IS PROVIDED BY MATHEW TINSLEY ""AS IS"" AND ANY
 *	EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *	WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 *	DISCLAIMED. IN NO EVENT SHALL <copyright holder> BE LIABLE FOR ANY
 *	DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 *	(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 *	LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 *	ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 *	(INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 *	SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class Jibborish generator.
 */


var LoremIpsum = function LoremIpsum() {};
/**
 * Average number of words per sentence.
 * @constant {number}
 */


LoremIpsum.WORDS_PER_SENTENCE_AVG = 24.460;
/**
 * Standard deviation of the number of words per sentence.
 * @constant {number}
 */

LoremIpsum.WORDS_PER_SENTENCE_STD = 5.080;
/**
 * List of possible words.
 * @constant {Array.string}
 */

LoremIpsum.WORDS = ["lorem", "ipsum", "dolor", "sit", "amet", "consectetur", "adipiscing", "elit", "curabitur", "vel", "hendrerit", "libero", "eleifend", "blandit", "nunc", "ornare", "odio", "ut", "orci", "gravida", "imperdiet", "nullam", "purus", "lacinia", "a", "pretium", "quis", "congue", "praesent", "sagittis", "laoreet", "auctor", "mauris", "non", "velit", "eros", "dictum", "proin", "accumsan", "sapien", "nec", "massa", "volutpat", "venenatis", "sed", "eu", "molestie", "lacus", "quisque", "porttitor", "ligula", "dui", "mollis", "tempus", "at", "magna", "vestibulum", "turpis", "ac", "diam", "tincidunt", "id", "condimentum", "enim", "sodales", "in", "hac", "habitasse", "platea", "dictumst", "aenean", "neque", "fusce", "augue", "leo", "eget", "semper", "mattis", "tortor", "scelerisque", "nulla", "interdum", "tellus", "malesuada", "rhoncus", "porta", "sem", "aliquet", "et", "nam", "suspendisse", "potenti", "vivamus", "luctus", "fringilla", "erat", "donec", "justo", "vehicula", "ultricies", "varius", "ante", "primis", "faucibus", "ultrices", "posuere", "cubilia", "curae", "etiam", "cursus", "aliquam", "quam", "dapibus", "nisl", "feugiat", "egestas", "class", "aptent", "taciti", "sociosqu", "ad", "litora", "torquent", "per", "conubia", "nostra", "inceptos", "himenaeos", "phasellus", "nibh", "pulvinar", "vitae", "urna", "iaculis", "lobortis", "nisi", "viverra", "arcu", "morbi", "pellentesque", "metus", "commodo", "ut", "facilisis", "felis", "tristique", "ullamcorper", "placerat", "aenean", "convallis", "sollicitudin", "integer", "rutrum", "duis", "est", "etiam", "bibendum", "donec", "pharetra", "vulputate", "maecenas", "mi", "fermentum", "consequat", "suscipit", "aliquam", "habitant", "senectus", "netus", "fames", "quisque", "euismod", "curabitur", "lectus", "elementum", "tempor", "risus", "cras"];
/**
 * Generate "Lorem ipsum" style words.
 * @param numWords {number} Number of words to generate.
 * @return {string} "Lorem ipsum..."
 */

LoremIpsum.prototype.generate = function (numWords, punctuate) {
  var words, ii, position, word, current, sentences, sentenceLength, sentence;
  /**
  * @default 100
  */

  numWords = numWords || 100;
  words = [LoremIpsum.WORDS[0], LoremIpsum.WORDS[1]];
  numWords -= 2;

  for (ii = 0; ii < numWords; ii++) {
    position = Math.floor(Math.random() * LoremIpsum.WORDS.length);
    word = LoremIpsum.WORDS[position];

    if (ii > 0 && words[ii - 1] === word) {
      ii -= 1;
    } else {
      words[ii] = word;
    }
  }

  sentences = [];
  current = 0;

  while (numWords > 0) {
    sentenceLength = this.getRandomSentenceLength();

    if (numWords - sentenceLength < 4) {
      sentenceLength = numWords;
    }

    numWords -= sentenceLength;
    sentence = [];

    for (ii = current; ii < current + sentenceLength; ii++) {
      sentence.push(words[ii]);
    }

    if (punctuate) {
      sentence = this.punctuate(sentence);
    }

    current += sentenceLength;
    sentences.push(sentence.join(" "));
  }

  return sentences.join(" ");
};
/**
 * Insert commas and periods in the given sentence.
 * @param {Array.string} sentence List of words in the sentence.
 * @return {Array.string} Sentence with punctuation added.
 */


LoremIpsum.prototype.punctuate = function (sentence) {
  var wordLength, numCommas, ii, position;
  wordLength = sentence.length;
  /* End the sentence with a period. */

  sentence[wordLength - 1] += ".";

  if (wordLength < 4) {
    return sentence;
  }

  numCommas = this.getRandomCommaCount(wordLength);

  for (ii = 0; ii <= numCommas; ii++) {
    position = Math.round(ii * wordLength / (numCommas + 1));

    if (position < wordLength - 1 && position > 0) {
      /* Add the comma. */
      sentence[position] += ",";
    }
  }
  /* Capitalize the first word in the sentence. */


  sentence[0] = sentence[0].charAt(0).toUpperCase() + sentence[0].slice(1);
  return sentence;
};
/**
 * Produces a random number of commas.
 * @param {number} wordLength Number of words in the sentence.
 * @return {number} Random number of commas
 */


LoremIpsum.prototype.getRandomCommaCount = function (wordLength) {
  var base, average, standardDeviation;
  /* Arbitrary. */

  base = 6;
  average = Math.log(wordLength) / Math.log(base);
  standardDeviation = average / base;
  return Math.round(this.gaussMS(average, standardDeviation));
};
/**
 * Produces a random sentence length based on the average word length
 * of an English sentence.
 * @return {number} Random sentence length
 */


LoremIpsum.prototype.getRandomSentenceLength = function () {
  return Math.round(this.gaussMS(LoremIpsum.WORDS_PER_SENTENCE_AVG, LoremIpsum.WORDS_PER_SENTENCE_STD));
};
/**
 * Produces a random number.
 * @return {number} Random number
 */


LoremIpsum.prototype.gauss = function () {
  return Math.random() * 2 - 1 + (Math.random() * 2 - 1) + (Math.random() * 2 - 1);
};
/**
 * Produces a random number with Gaussian distribution.
 * @param {number} mean
 * @param {number} standardDeviation
 * @return {number} Random number
 */


LoremIpsum.prototype.gaussMS = function (mean, standardDeviation) {
  return Math.round(this.gauss() * standardDeviation + mean);
};

function Tickers() {}

Tickers.TICKERS = ["PIH", "FLWS", "FCCY", "SRCE", "VNET", "TWOU", "JOBS", "CAFD", "EGHT", "AVHI", "SHLM", "AAON", "ABAX", "ABEO", "ABEOW", "ABIL", "ABMD", "AXAS", "ACIU", "ACIA", "ACTG", "ACHC", "ACAD", "ACST", "AXDX", "XLRN", "ANCX", "ARAY", "ACRX", "ACET", "AKAO", "ACHN", "ACIW", "ACRS", "ACNB", "ACOR", "ACTS", "ACPW", "ATVI", "ACTA", "ACUR", "ACXM", "ADMS", "ADMP", "ADAP", "ADUS", "AEY", "IOTS", "ADMA", "ADBE", "ADTN", "ADRO", "AAAP", "ADES", "AEIS", "AMD", "ADXS", "ADXSW", "ADVM", "MAUI", "AEGR", "AEGN", "AGLE", "AEHR", "AMTX", "AEPI", "AERI", "AVAV", "AEZS", "AEMD", "AFMD", "AGEN", "AGRX", "AGYS", "AGIO", "AGNC", "AGNCB", "AGNCP", "AGFS", "AGFSW", "AIMT", "AIRM", "AIRT", "ATSG", "AIRG", "AMCN", "AIXG", "AKAM", "AKTX", "AKBA", "AKER", "AKRX", "ALRM", "ALSK", "AMRI", "ALBO", "ABDC", "ADHD", "ALDR", "ALDX", "ALXN", "ALCO", "ALGN", "ALIM", "ALJJ", "ALKS", "ABTX", "ALGT", "AIQ", "AHGP", "AMMA", "ARLP", "AHPI", "AMOT", "ALQA", "ALLT", "MDRX", "AFAM", "ALNY", "AOSL", "GOOG", "GOOGL", "SMCP", "ATEC", "ASPS", "AIMC", "AMAG", "AMRN", "AMRK", "AYA", "AMZN", "AMBC", "AMBCW", "AMBA", "AMCX", "DOX", "AMDA", "AMED", "UHAL", "ATAX", "AMOV", "AAL", "ACSF", "ACAS", "AETI", "AMNB", "ANAT", "APEI", "ARII", "AMRB", "AMSWA", "AMSC", "AMWD", "CRMT", "ABCB", "AMSF", "ASRV", "ASRVP", "ATLO", "AMGN", "FOLD", "AMKR", "AMPH", "IBUY", "AMSG", "AMSGP", "ASYS", "AFSI", "AMRS", "ADI", "ALOG", "AVXL", "ANCB", "ANDA", "ANDAR", "ANDAU", "ANDAW", "ANGI", "ANGO", "ANIP", "ANIK", "ANSS", "ATRS", "ANTH", "ABAC", "APOG", "APOL", "AINV", "APPF", "AAPL", "ARCI", "APDN", "APDNW", "AGTC", "AMAT", "AMCC", "AAOI", "AREX", "APTI", "APRI", "APVO", "APTO", "AQMS", "AQXP", "ARDM", "ARLZ", "PETX", "ABUS", "ARCW", "ABIO", "RKDA", "ARCB", "ACGL", "ACGLP", "APLP", "ACAT", "ARDX", "ARNA", "ARCC", "AGII", "AGIIL", "ARGS", "ARIS", "ARIA", "ARKR", "ARTX", "ARWA", "ARWAR", "ARWAU", "ARWAW", "ARQL", "ARRY", "ARRS", "DWAT", "AROW", "ARWR", "ARTNA", "ARTW", "ASBB", "ASNA", "ASND", "ASCMA", "APWC", "ASML", "AZPN", "ASMB", "ASFI", "ASTE", "ATRO", "ALOT", "ASTC", "ASUR", "ATAI", "ATRA", "ATHN", "ATHX", "AAPC", "AAME", "ACBI", "ACFC", "ABY", "ATLC", "AAWW", "AFH", "TEAM", "ATNI", "ATOM", "ATOS", "ATRC", "ATRI", "ATTU", "LIFE", "AUBN", "BOLD", "AUDC", "AUPH", "EARS", "ABTL", "ADSK", "ADP", "AVEO", "AVXS", "AVNW", "AVID", "AVGR", "AVIR", "CAR", "AHPAU", "AWRE", "AXAR", "AXARU", "AXARW", "ACLS", "AXGN", "AXSM", "AXTI", "AZRX", "BCOM", "RILY", "RILYL", "BOSC", "BEAV", "BIDU", "BCPC", "BWINA", "BWINB", "BLDP", "BANF", "BANFP", "BCTF", "BKMU", "BOCH", "BMRC", "BKSC", "BOTJ", "OZRK", "BFIN", "BWFG", "BANR", "BZUN", "TAPR", "DLBL", "BHAC", "BHACR", "BHACU", "BHACW", "BBSI", "BSET", "BYBK", "BV", "BCBP", "BECN", "BSF", "BBGI", "BEBE", "BBBY", "BGNE", "BELFA", "BELFB", "BLPH", "BLCM", "BNCL", "BNFT", "BNTC", "BNTCW", "BGCP", "BGFV", "BASI", "ORPN", "BIOC", "BCRX", "BDSI", "BIIB", "BIOL", "BLFS", "BLRX", "BMRN", "BMRA", "BVXV", "BVXVW", "BPTH", "BIOS", "BBC", "BBP", "BSTC", "BSTG", "BSPM", "TECH", "BEAT", "BJRI", "BBOX", "BDE", "BLKB", "BBRY", "HAWK", "BL", "BKCC", "ADRA", "ADRD", "ADRE", "ADRU", "BLMN", "BCOR", "BLBD", "BUFF", "BHBK", "NILE", "BLUE", "BKEP", "BKEPP", "BPMC", "ITEQ", "BMCH", "BNCN", "BOBE", "BOFI", "BOFIL", "WIFI", "BOJA", "BOKF", "BOKFL", "BNSO", "BPFH", "BPFHP", "BPFHW", "EPAY", "BLVD", "BLVDU", "BLVDW", "BCLI", "BBRG", "BDGE", "BLIN          ", "BRID", "BCOV", "AVGO", "BSFT", "BVSN", "BYFC", "BWEN", "BRCD", "BRKL", "BRKS", "BRKR", "BMTC", "BLMT", "BSQR", "BWLD", "BLDR", "BMLA", "BUR", "CFFI", "CHRW", "CA", "CCMP", "CDNS", "CDZI", "CACQ", "CZR", "CSTE", "PRSS", "CLBS", "CLMS", "CHY", "CHI", "CCD", "CHW", "CGO", "CSQ", "CAMP", "CVGW", "CFNB", "CALA", "CALD", "CALM", "CLMT", "ABCD", "CAC", "CAMT", "CSIQ", "CGIX", "CPHC", "CPLA", "CBF", "CCBG", "CPLP", "CSWC", "CPTA", "CLAC", "CLACU", "CLACW", "CFFN", "CAPN", "CAPNW", "CAPR", "CSTR", "CPST", "CARA", "CARB", "CCN", "CCNWW", "CFNL", "CRME", "CSII", "CATM", "CDNA", "CECO", "CTRE", "CKEC", "CLBH", "CARO", "CART", "CRZO", "TAST", "CRTN", "CARV", "CASM", "CACB", "CASC", "CWST", "CASY", "CASI", "CASS", "CATB", "CBIO", "CPRX", "CATY", "CATYW", "CVCO", "CAVM", "CBFV", "CBOE", "CDK", "CDW", "CECE", "CELG", "CELGZ", "CLDX", "APOP", "APOPW", "CLRB", "CLRBW", "CLRBZ", "CLLS", "CBMG", "CLSN", "CYAD", "CEMP", "CETX", "CDEV", "CDEVW", "CSFL", "CETV", "CFBK", "CENT", "CENTA", "CVCY", "CFCB", "CENX", "CNBKA", "CNTY", "CRNT", "CERC", "CERCW", "CERCZ", "CERN", "CERU", "CERS", "KOOL", "CEVA", "CFCO", "CFCOU", "CFCOW", "CSBR", "CYOU", "HOTR", "HOTRW", "CTHR", "GTLS", "CHTR", "CHFN", "CHKP", "CHEK", "CHEKW", "CEMI", "CHFC", "CCXI", "CHMG", "CHKE", "CHMA", "PLCE", "CMRX", "CADC", "CALI", "CAAS", "CBAK", "CBPO", "CCCL", "CCCR", "CCRC", "JRJC", "HGSH", "CNIT", "CJJD", "CLDC", "CLDCW", "HTHT", "CHNR", "CREG", "CNTF", "CXDC", "CCIH", "CNET", "IMOS", "CDXC", "CHSCL", "CHSCM", "CHSCN", "CHSCO", "CHSCP", "CHDN", "CHUY", "CDTX", "CMCT", "CMPR", "CINF", "CIDM", "CTAS", "CPHR", "CRUS", "CSCO", "CTRN", "CZNC", "CZWI", "CZFC", "CIZN", "CTXS", "CHCO", "CIVB", "CIVBP", "CDTI", "CLNE", "CLNT", "CLFD", "CLRO", "CLSD", "CLIR", "CBLI", "CSBK", "CLVS", "CMFN", "CME", "CCNE", "CISG", "CNV", "CWAY", "COBZ", "COKE", "CDXS", "CVLY", "JVA", "CCOI", "CGNT", "COGT", "CGNX", "CTSH", "COHR", "CHRS", "COHU", "CLCT", "COLL", "CIGI", "CBAN", "CLCD", "COLB", "COLM", "CMCO", "CBMX", "CBMXW", "CMCSA", "CBSH", "CBSHP", "CUBN", "CHUBA", "CHUBK", "CVGI", "COMM", "CSAL", "JCS", "ESXB", "CYHHZ", "CTBI", "CWBC", "CVLT", "CGEN", "CPSI", "CTG", "SCOR", "CHCI", "CMTL", "CNAT", "CNCE", "CXRX", "CCUR", "CDOR", "CFMS", "CNFR", "CNMD", "CTWS", "CNOB", "CNXR", "CONN", "CNSL", "CWCO", "CPSS", "CFRX", "CFRXW", "CTRV", "CTRL", "CPAA", "CPAAU", "CPAAW", "CPRT", "COYN", "COYNW", "CRBP", "CORT", "CORE", "CORI", "CSOD", "CRVL", "CRVS", "CSGP", "COST", "CPAH", "ICBK", "COUP", "CVTI", "COVS", "COWN", "COWNL", "PMTS", "CPSH", "CRAI", "CBRL", "BREW", "CRAY", "CACC", "GLDI", "SLVO", "CREE", "CRESY", "CRSP", "CRTO", "CROX", "CCRN", "XRDC", "CRDS", "CRWS", "CYRX", "CYRXW", "CSGS", "CCLP", "CSPI", "CSWI", "CSX", "CTIC", "CTIB", "CTRP", "CUNB", "CUI", "CPIX", "CMLS", "CRIS", "CUTR", "CVBF", "CVV", "CYAN", "CYBR", "CYBE", "CYCC", "CYCCP", "CBAY", "CYNO", "CY", "CYRN", "CONE", "CYTK", "CTMX", "CYTX", "CYTXW", "CTSO", "CYTR", "DJCO", "DAKT", "DRIO", "DRIOW", "DZSI", "DAIO", "DTLK", "DRAM", "DWCH", "PLAY", "DTEA", "DWSN", "DBVT", "DFRG", "TACO", "TACOW", "DCTH", "DMPI", "DGAS", "DELT", "DELTW", "DENN", "XRAY", "DEPO", "DSCI", "DERM", "DEST", "DXLG", "DSWL", "DTRM", "DXCM", "DXTR", "DHXM", "DHIL", "FANG", "DCIX", "DRNA", "DFBG", "DFFN", "DGII", "DMRC", "DRAD", "DGLY", "APPS", "DCOM", "DMTX", "DIOD", "DPRX", "DISCA", "DISCB", "DISCK", "DISH", "DVCR", "SAUC", "DLHC", "BOOM", "DNBF", "DLTR", "DGICA", "DGICB", "DMLP", "DORM", "EAGL", "EAGLU", "EAGLW", "DRWI", "DRYS", "DSKX", "DSPG", "DTSI", "DLTH", "DNKN", "DRRX", "DXPE", "DYSL", "DYNT", "DVAX", "ETFC", "EBMT", "EGBN", "EGLE", "EGRX", "IGLEU", "ELNK", "EWBC", "EACQ", "EACQU", "EACQW", "EML", "EVBS", "EVGBC", "EVSTC", "EVLMC", "EBAY", "EBAYL", "EBIX", "ELON", "ECHO", "SATS", "EEI", "ECAC", "ECACR", "ECACU", "ESES", "EDAP", "EDGE", "EDGW", "EDIT", "EDUC", "EFUT", "EGAN", "EGLT", "EHTH", "EIGR", "EKSO", "LOCO", "EMITF", "ESLT", "ERI", "ESIO", "EA", "EFII", "ELSE", "ELEC", "ELECU", "ELECW", "EBIO", "DWAC", "CAPX", "ESBK", "ELTK", "EMCI", "EMCF", "EMKR", "EMMS", "NYNY", "ERS", "ENTA", "ECPG", "WIRE", "ENDP", "ECYT", "ELGX", "EIGI", "WATT", "EFOI", "ERII", "ENOC", "ENG", "ENPH", "ESGR", "ENFC", "ENTG", "ENTL", "ETRM", "EBTC", "EFSC", "EGT", "ENZY          ", "EPZM", "PLUS", "EQIX", "EQFN", "EQBK", "ERIC", "ERIE", "ESCA", "ESPR", "ESSA", "EPIX", "ESND", "UTES", "ETSY", "CLWT", "EEFT", "ESEA", "EVEP", "EVBG", "EVK", "MRAM", "EVLV", "EVOK", "EVOL", "EXA", "EXAS", "EXAC", "EXEL", "EXFO", "EXLS", "EXPE", "EXPD", "EXPO", "ESRX", "XOG", "EXTR", "EYEG", "EYEGW", "EZPW", "FFIV", "FB", "FRP", "FALC", "DAVE", "FARM", "FFKT", "FMNB", "FARO", "FAST", "FATE", "FBSS", "FBRC", "FDML", "FNHC", "FHCO", "FENX", "GSM", "FCSC", "FGEN", "ONEQ", "LION", "FDUS", "FRGI", "FSAM", "FSC", "FSCFL", "FSFR", "FITB", "FITBI", "FNGN", "FISI", "FNSR", "FNJN", "FEYE", "FBNC", "FNLC", "FRBA", "BUSE", "FBIZ", "FCAP", "FCFS", "FCNCA", "FCBC", "FCCO", "FCFP", "FBNK", "FDEF", "FFBC", "FFBCW", "FFIN", "THFF", "FFNW", "FFWM", "FGBI", "FHB", "INBK", "INBKL", "FIBK", "FRME", "FMBH", "FMBI", "FNBC", "FNWB", "FSFG", "FSLR", "FSBK", "FAAR", "FPA", "BICK", "FBZ", "FCAN", "FTCS", "FCEF", "FCA", "FDT", "FDTS", "FVC", "FV", "IFV", "FEM", "FEMB", "FEMS", "FTSM", "FEP", "FEUZ", "FGM", "FTGC", "FTHI", "HYLS", "FHK", "FTAG", "FTRI", "FPXI", "YDIV", "SKYY", "FJP", "FEX", "FTC", "FTA", "FLN", "FTLB", "LMBS", "FMB", "FMK", "FNX", "FNY", "FNK", "FAD", "FAB", "MDIV", "MCEF", "QABA", "FTXO", "QCLN", "GRID", "CIBR", "FTXG", "CARZ", "FTXN", "FTXH", "FTXD", "RDVY", "FTXL", "FONE", "TDIV", "FTXR", "QQEW", "QQXT", "QTEC", "AIRR", "QINC", "RFAP", "RFDI", "RFEM", "RFEU", "FTSL", "FYX", "FYC", "FYT", "FKO", "FCVT", "FDIV", "FSZ", "FTW", "TUSA", "FKU", "FUNC", "FUSB", "SVVC", "FSV", "FISV", "FIVE", "FPRX", "FVE", "FIVN", "FLML", "FLEX", "FLKS", "FLXN", "SKOR", "LKOR", "MBSD", "ASET", "ESGG", "ESG", "QLC", "FPAY", "FLXS", "FLIR", "FLDM", "FFIC", "FOMX", "FOGO", "FONR", "FH", "FORM", "FORTY", "FORR", "FRTA", "FTNT", "FBIO", "FWRD", "FORD", "FWP", "FOSL", "FMI", "FOXF", "FRAN", "FELE", "FRED", "RAIL", "FEIM", "FRPT", "FTEO", "FTR", "FTRPR", "FRPH", "FSBW", "FSBC", "FTD", "FTEK", "FCEL", "FLGT", "FORK", "FLL", "FULT", "FNCX", "FSNN", "FFHL", "FXCM", "GK", "WILC", "GAIA", "GLPG", "GALT", "GALTU", "GALTW", "GALE", "GLMD", "GLPI", "GPIC", "GRMN", "GARS", "GDS", "GEMP", "GENC", "GNCMA", "GFN", "GFNCP", "GFNSL", "GENE", "GNUS", "GNMK", "GNCA", "GHDX", "GNTX", "THRM", "GNVC", "GTWN", "GEOS", "GABC", "GERN", "GEVO", "ROCK", "GIGM", "GIGA", "GIII", "GILT", "GILD", "GBCI", "GLAD", "GLADO", "GOOD", "GOODM", "GOODO", "GOODP", "GAIN", "GAINM", "GAINN", "GAINO", "LAND", "LANDP", "GLBZ", "GBT", "ENT", "GBLI", "GBLIZ", "GPAC", "GPACU", "GPACW", "SELF", "GSOL", "GWRS", "KRMA", "FINX", "ACTX", "BFIT", "SNSR", "LNGR", "MILN", "EFAS", "QQQC", "BOTZ", "CATH", "SOCL", "ALTY", "SRET", "YLCO", "GLBS", "GLUU", "GLYC", "GOGO", "GLNG", "GMLP", "GDEN", "GOGL", "GBDC", "GTIM", "GPRO", "GMAN", "GOV", "GOVNI", "GPIA", "GPIAU", "GPIAW", "LOPE", "GRVY", "FULLL", "GECC", "GEC", "GLDD", "GSBC", "GNBC", "GRBK", "GPP", "GPRE", "GCBC", "GLRE", "GSUM", "GRIF", "GRFS", "GRPN", "OMAB", "GGAL", "GSIT", "GSVC", "GTXI", "GTYH", "GTYHU", "GTYHW", "GBNK", "GFED", "GUID", "GIFI", "GURE", "GPOR", "GWPH", "GWGH", "GYRO", "HEES", "HLG", "HNRG", "HALL", "HALO", "HBK", "HBHC", "HBHCL", "HNH", "HAFC", "HQCL", "HONE", "HDNG", "HLIT", "HRMN", "HRMNU", "HRMNW", "TINY", "HBIO", "HCAP", "HCAPL", "HAS", "HA", "HCOM", "HWKN", "HWBK", "HAYN", "HDS", "HIIQ", "HCSG", "HQY", "HSTM", "HWAY", "HTLD", "HTLF", "HTBX", "HSII", "HELE", "HMNY", "HMTV", "HNNA", "HCAC", "HCACU", "HCACW", "HSIC", "HTBK", "HFWA", "HEOP", "HCCI", "MLHR", "HRTX", "HSKA", "HIBB", "SNLN", "HPJ", "HIHO", "HIMX", "HIFS", "HSGX", "HMNF", "HMSY", "HOLI", "HOLX", "HBCP", "HOMB", "HFBL", "HMST", "HMTA", "HTBI", "HMU", "CETC", "HOFT", "HOPE", "HFBC", "HBNC", "HZNP", "HRZN", "HDP", "HPT", "HPTRP", "TWNK", "TWNKW", "HMHC", "HWCC", "HOVNP", "HBMD", "HSNI", "HTGM", "HUBG", "HSON", "HDSN", "HUNTU", "HBAN", "HBANN", "HBANO", "HBANP", "HURC", "HURN", "HCM", "HBP", "HDRA", "HDRAR", "HDRAU", "HDRAW", "HYGS", "IDSY", "IAC", "IKGH", "IBKC", "IBKCO", "IBKCP", "ICAD", "IEP", "ICFI", "ICLR", "ICON", "ICUI", "IPWR", "INVE", "IDRA", "IDXX", "IESC", "IROQ", "IRG", "RXDX", "INFO", "IIVI", "KANG", "IKNX", "ILG", "ILMN", "ISNS", "IMMR", "ICCC", "IMDZ", "IMNP          ", "IMGN", "IMMU", "IPXL", "PI", "IMMY", "INCR", "INCY", "INDB", "IBCP", "IBTX", "IDSA", "INFN", "INFI", "IPCC", "III", "IFON", "IMKTA", "INWK", "INNL", "INOD", "IPHS", "IOSP", "ISSC", "INVA", "INGN", "ITEK", "INOV", "INO", "INSG", "NSIT", "ISIG", "INSM", "IIIN", "PODD", "INSY", "NTEC", "IART", "IDTI", "INTC", "IQNT", "NTLA", "IPCI", "IPAR", "IBKR", "ININ", "ICPT", "IDCC", "TILE", "LINK", "IMI", "INAP", "IBOC", "ISCA", "IGLD", "IIJI", "IDXG", "XENT", "INTX", "ISIL", "IVAC", "INTL", "ITCI", "IIN", "INTU", "ISRG", "INVT", "SNAK", "ISTR", "ISBC", "ITIC", "NVIV", "IVTY", "IONS", "IPAS", "DTYS", "DTYL", "DTUS", "DTUL", "DFVS", "DFVL", "FLAT", "DLBS", "STPP", "IPGP", "IRMD", "IRTC", "IRIX", "IRDM", "IRDMB", "IRBT", "IRWD", "IRCP", "PMPT", "SLQD", "TLT", "AIA", "COMT", "IXUS", "FALN", "IFEU", "IFGL", "IGF", "GNMA", "HYXE", "JKI", "ACWX", "ACWI", "AAXJ", "EWZS", "MCHI", "ESGD", "SCZ", "ESGE", "EEMA", "EUFN", "IEUS", "MPCT", "ENZL", "QAT", "UAE", "IBB", "SOXX", "EMIF", "ICLN", "WOOD", "INDY", "ISHG", "IGOV", "ISLE", "ISRL", "ITI", "ITRI", "ITRN", "ITUS", "IVENC", "IVFGC", "IVFVC", "XXIA", "IXYS", "IZEA", "JJSF", "MAYS", "JBHT", "JCOM", "JASO", "JKHY", "JACK", "JXSB", "JAGX", "JAKK", "JMBA", "JRVR", "JSML", "JSMD", "JASN", "JASNW", "JAZZ", "JD", "JSYN", "JSYNR", "JSYNU", "JSYNW", "JBLU", "JTPY", "JCTCF", "JIVE", "WYIG", "WYIGU", "WYIGW", "JBSS", "JOUT", "JNP", "JUNO", "KTWO", "KALU", "KALV", "KMDA", "KNDI", "KPTI", "KBSF", "KCAP", "KRNY", "KELYA", "KELYB", "KMPH", "KFFB", "KERX", "KEQU", "KTEC", "KTCC", "KFRC", "KE", "KBAL", "KIN", "KGJI", "KINS", "KONE", "KNSL", "KIRK", "KITE", "KTOV", "KTOVW", "KLAC", "KLRE", "KLREU", "KLREW", "KLXI", "KONA", "KZ", "KOPN", "KRNT", "KOSS", "KWEB", "KTOS", "KLIC", "KURA", "KVHI", "FSTR", "LJPC", "LSBK", "LSBG", "LBAI", "LKFN", "LAKE", "LRCX", "LAMR", "LANC", "LCA", "LCAHU", "LCAHW", "LNDC", "LARK", "LMRK", "LMRKO", "LMRKP", "LE", "LSTR", "LNTH", "LTRX", "LSCC", "LAWS", "LAYN", "LCNB", "LBIX", "LGCY", "LGCYO", "LGCYP", "LTXB", "DDBI", "EDBI", "LVHD", "UDBI", "LMAT", "TREE", "LXRX", "LGIH", "LHCG", "LLIT", "LBRDA", "LBRDK", "LEXEA", "LEXEB", "LBTYA", "LBTYB", "LBTYK", "LILA", "LILAK", "LVNTA", "LVNTB", "QVCA", "QVCB", "BATRA", "BATRK", "LMCA", "LMCK", "LSXMA", "LSXMB", "LSXMK", "TAX", "LTRPA", "LTRPB", "LPNT", "LCUT", "LFVN", "LWAY", "LGND", "LTBR", "LPTH", "LMB", "LLNW", "LMNR", "LINC", "LECO", "LIND", "LINDW", "LLTC", "LBIO", "LIOX", "LPCN", "LQDT", "LFUS", "LIVN", "LOB", "LIVE", "LPSN", "LKQ", "LMFA", "LMFAW", "LMIA", "LOGI", "LOGM", "EVAR", "CNCR", "LONE", "LTEA", "LORL", "LOXO", "LPTN", "LPLA", "LRAD", "LYTS", "LULU", "LITE", "LMNX", "LMOS", "LUNA", "MBTF", "MACQ", "MACQU", "MACQW", "MIII", "MIIIU", "MIIIW", "MBVX", "MCBC", "MFNC", "MTSI", "MCUR", "MGNX", "MDGL", "MAGS", "MGLN", "MPET", "MGIC", "CALL", "MNGA", "MGYR", "MHLD", "MSFG", "COOL", "MMYT", "MBUU", "MLVF", "MAMS", "TUSK", "MANH", "LOAN", "MNTX", "MTEX", "MNKD", "MANT", "MARA", "MCHX", "MARPS", "MRNS", "MKTX", "MRLN", "MAR", "MBII", "MRTN", "MMLP", "MRVL", "MASI", "MTCH", "MATN", "MTLS", "MTRX", "MAT", "MATR", "MATW", "MXIM", "MXPT", "MXWL", "MZOR", "MBFI", "MBFIP", "MCFT", "MGRC", "MDCA", "MFIN", "MFINL", "MDGN", "MTBC", "MTBCP", "MNOV", "MDSO", "MDGS", "MDWD", "MDVX", "MDVXW", "MEDP", "MEET", "MEIP", "MPEL", "MLNX", "MELR", "MEMP", "MENT", "MTSL", "MELI", "MBWM", "MERC", "MBVT", "MRCY", "EBSB", "VIVO", "MMSI", "MACK", "MSLI", "MRUS", "MLAB", "MESO", "CASH", "MBLX", "MEOH", "MFRI", "MGCD", "MGEE", "MGPI", "MCHP", "MU", "MICT", "MICTW", "MSCC", "MSFT", "MSTR", "MVIS", "MPB", "MTP", "MCEP", "MBRG", "MBCN", "MSEX", "MSBI", "MOFG", "MIME", "MDXG", "MNDO", "MB", "NERV", "MRTX", "MIRN", "MSON", "MIND", "MINDP", "MITK", "MITL", "MKSI", "MMAC", "MINI", "MOBL", "MOCO", "MDSY", "MLNK", "MBRX", "MNTA", "MOMO", "MCRI", "MDLZ", "MGI", "MPWR", "TYPE", "MNRO", "MRCC", "MNST", "MSDI", "MSDIW", "MHGC", "MORN", "MOSY", "MTFB", "MTFBW", "MPAA", "MDM", "MOXC", "MRVC", "MSBF", "MSG", "MTGE", "MTGEP", "MTSC", "LABL", "MFSF", "MYSZ", "MYL", "MYOK", "MYOS", "MYRG", "MYGN", "NBRV", "NAKD", "NNDM", "NANO", "NSTG", "NH", "NK", "NSSC", "NDAQ", "NTRA", "NATH", "NAUH", "NKSH", "FIZZ", "NCMI", "NCOM", "NGHC", "NGHCN", "NGHCO", "NGHCP", "NGHCZ", "NHLD", "NATI", "NRCIA", "NRCIB", "NSEC", "NWLI", "NAII", "NHTC", "NATR", "BABY", "NAVI", "NBTB", "NCIT", "NKTR", "NEOG", "NEO", "NEON", "NEOS", "NEOT", "NVCN", "NEPT", "UEPS", "NETE", "NTAP", "NTES", "NFLX", "NTGR", "NLST", "NTCT", "NTWK", "CUR", "NBIX", "NDRM", "NURO", "NUROW", "NYMT", "NYMTO", "NYMTP", "NLNK", "NWS", "NWSA", "NEWS", "NEWT", "NEWTL", "NEWTZ", "NXEO", "NXEOU", "NXEOW", "NXST", "NVET", "NFEC", "EGOV", "NICE", "NICK", "NCBS", "NIHD", "NVLS", "NMIH", "NNBR", "NDLS", "NDSN", "NSYS", "NBN", "NTIC", "NTRS", "NTRSP", "NFBK", "NRIM", "NWBI", "NWBO", "NWBOW", "NWPX", "NCLH", "NWFL", "NVFY", "NVMI", "NVDQ", "NOVN", "NOVT", "NVAX", "NVCR", "NVGN", "NUAN", "NMRX", "NTNX", "NUTR", "NTRI", "NUVA", "NVTR", "QQQX", "NVEE", "NVEC", "NVDA", "NXPI", "NXTM", "NXTD", "NXTDW", "NYMX", "OIIM", "OVLY", "OASM", "OBLN", "OBCI", "OPTT", "ORIG", "OSHC", "OCFC", "OCRX", "OCLR", "OFED", "OCUL", "OCLS", "OCLSW", "OMEX", "ODP", "OFS", "OHAI", "OVBC", "OHRP", "ODFL", "OLBK", "ONB", "OPOF", "OSBC", "OSBCP", "OLLI", "ZEUS", "OFLX", "OMER", "OMCL", "ON", "OTIV", "ONS", "ONSIW", "ONSIZ", "OGXI", "OMED", "ONTX", "ONTXW", "ONCS", "OHGI", "ONVI", "OTEX", "OPXA", "OPXAW", "OPGN", "OPGNW", "OPHT", "OPK", "OBAS", "OCC", "OPHC", "OPB", "ORMP", "OSUR", "ORBC", "ORBK", "ORLY", "OREX", "ONVO", "SEED", "OACQ", "OACQR", "OACQU", "OACQW", "OESX", "ORIT", "ORRF", "OFIX", "OSIS", "OSIR", "OSN", "OTEL", "OTIC", "OTTW", "OTTR", "OVAS", "OSTK", "OXBR", "OXBRW", "OXFD", "OXLC", "OXLCN", "OXLCO", "PFIN", "PTSI", "PCAR", "PACE", "PACEU", "PACEW", "PACB", "PCBK", "PEIX", "PMBC", "PPBI", "PAAC", "PAACR", "PAACU", "PAACW", "PCRX", "PACW", "PTIE", "PAAS", "PNRA", "PANL", "PZZA", "FRSH", "PBNC", "PRTK", "PRXL", "PCYG", "PSTB", "PKBK", "PRKR", "PKOH", "PARN", "PTNR", "PBHC", "PATK", "PNBK", "PATI", "PEGI", "PDCO", "PTEN", "PAVM", "PAVMW", "PAYX", "PCTY", "PYDS", "PYPL", "PBBI", "CNXN", "PCMI", "PCTI", "PDCE", "PDFS", "PDLI", "PDVW", "SKIS", "PGC", "PEGA", "PCO", "PENN", "PFLT", "PNNT", "PWOD", "PTXP", "PEBO", "PEBK", "PFBX", "PFIS", "PBCT", "PUB", "PRCP", "PPHM", "PPHMP", "PRFT", "PFMT", "PERF", "PERI", "PESI", "PTX", "PERY", "PGLC", "PETS", "PFSW", "PGTI", "PZRX", "PHII", "PHIIK", "PAHC", "PHMD", "PLAB", "PICO", "PIRS", "PPC", "PME", "PNK", "PNFP", "PPSI", "PXLW", "PLPM", "PLXS", "PLUG", "PLBC", "PSTI", "PBSK", "PNTR", "PCOM", "POOL", "POPE", "PLKI", "BPOP", "BPOPM", "BPOPN", "PBIB", "PTLA", "PBPB", "PCH", "POWL", "POWI", "PSIX", "DWLV", "DWIN", "DWTR", "IDLB", "PRFZ", "PAGG", "PSAU", "IPKW", "LDRI", "LALT", "PNQI", "PDBC", "QQQ", "USLB", "PSCD", "PSCC", "PSCE", "PSCF", "PSCH", "PSCI", "PSCT", "PSCM", "PSCU", "VRIG", "PRAA", "PRAH", "PRAN", "PFBC", "PLPC", "PFBI", "PINC", "LENS", "PRGX", "PSMT", "PBMD", "PNRG", "PRMW", "PRIM", "BTEC", "GENY", "PSET", "PY", "PSC", "PRZM", "PVTB", "PVTBP", "PDEX", "IPDN", "PFIE", "PGNX", "PRGS", "DNAI", "PFPT", "PRPH", "PRQR", "BIB", "UBIO", "TQQQ", "ZBIO", "SQQQ", "BIS", "PSEC", "PTGX", "PRTO", "PTI", "PRTA", "PVBC", "PROV", "PBIP", "PSDV", "PMD", "PTC", "PTCT", "PULM", "PLSE", "PCYO", "IMED", "FINQ", "PXS", "QADA", "QADB", "QCRH", "QGEN", "QIWI", "QLTI", "QRVO", "QCOM", "QSII", "QBAK", "QLYS", "QTNA", "QRHC", "QUIK", "QDEL", "QPAC", "QPACU", "QPACW", "QNST", "QUMU", "QUNR", "QTNT", "RRD", "RARX", "RADA", "RDCM", "ROIA", "ROIAK", "RSYS", "RDUS", "RDNT", "RDWR", "RMBS", "RAND", "RLOG", "GOLD", "RNDB", "RPD", "RAVE", "RAVN", "ROLL", "TALL", "RICK", "RCMT", "RDI", "RDIB", "RGSE", "RELY", "RNWK", "RP", "RETA", "DAX", "QYLD", "RCON", "REPH", "RRGB", "RRR", "RDHL", "REGN", "RGNX", "RGLS", "REIS", "RELV", "MARK", "RNST", "REGI", "RNVA", "RNVAZ", "RCII", "RTK", "RGEN", "RPRX", "RBCAA", "FRBK", "REFR", "RESN", "RECN", "ROIC", "SALE", "RTRX", "RVNC", "RVEN", "RVLT", "RWLK", "REXX", "RFIL", "RGCO", "RIBT", "RIBTW", "RELL", "RIGL", "NAME", "RNET", "RTTR", "RVSB", "RLJE", "RMGN", "ROBO", "FUEL", "RMTI", "RCKY", "RMCF", "ROKA", "ROSG", "ROST", "RBPAA", "RGLD", "RPXC", "RTIX", "RBCN", "RUSHA", "RUSHB", "RUTH", "RXII", "RYAAY", "STBA", "SANW", "SCAC", "SCACU", "SCACW", "SBRA", "SBRAP", "SABR", "SAEX", "SAFT", "SAGE", "SAIA", "SAJA", "SALM", "SAL", "SAFM", "SASR", "SGMO", "SANM", "GCVRZ", "SPNS", "SRPT", "SBFG", "SBFGP", "SBAC", "SCSC", "SMIT", "SCHN", "SCHL", "SCLN", "SGMS", "SNI", "SCYX", "SEAC", "SBCF", "STX", "SHIP", "SRSC", "SHLD", "SHLDW", "SHOS", "SPNE", "SGEN", "EYES", "SCWX", "SNFCA", "SEIC", "SLCT", "SCSS", "SIR", "SELB", "SIGI", "LEDS", "SMTC", "SENEA", "SENEB", "SNH", "SNHNI", "SNHNL", "SNMX", "SRTS", "SRTSW", "SQBG", "MCRB", "SREV", "SFBS", "SEV", "SVBI", "SGOC", "SMED", "SHSP", "SHEN", "SHLO", "TYHT", "SHPG", "SCVL", "SHBI", "SHOR", "SFLY", "SIFI", "SIEB", "SIEN", "BSRR", "SWIR", "SIFY", "SIGM", "SGMA", "SGNL", "SBNY", "SBNYW", "SLGN", "SILC", "SLAB", "SIMO", "SPIL", "SSRI", "SAMG", "SFNC", "SLP", "SINA", "SBGI", "SINO", "SVA", "SIRI", "SITO", "SKYS", "SKLN", "SPU", "SKYW", "SWKS", "ISM", "JSM", "OSM", "SLM", "SLMAP", "SLMBP", "SND", "SMBK", "SWHC", "SMSI", "SMTX", "LNCE", "SRAX", "SCKT", "SODA", "SOHU", "SLRC", "SUNS", "SEDG", "SONC", "SOFO", "SONS", "SPHS", "SORL", "SRNE", "SOHO", "SOHOB", "SOHOM", "SFBC", "SSB", "SFST", "SMBC", "SONA", "SBSI", "OKSB", "SP", "SPAN", "SBSA", "SGRP", "SPKE", "ONCE", "SPAR", "SPTN", "DWFI", "SPPI", "ANY", "SPEX", "SPI", "SAVE", "SPLK", "SPOK", "SPWH", "SBPH", "FUND", "SFM", "SPSC", "SSNC", "STAA", "STAF", "STMP", "STLY", "SPLS", "SBLK", "SBLKL", "SBUX", "STRZA", "STRZB", "STFC", "STBZ", "SNC", "STDY", "GASS", "STLD", "SMRT", "STLR", "STLRU", "STLRW", "SBOT", "STEM", "STML", "SRCL", "SRCLP", "STRL", "SHOO", "SSFN", "SYBT", "BANX", "SGBK", "SSKN", "SSYS", "STRT", "STRS", "STRA", "STRM", "SBBP", "STB", "SCMP", "SUMR", "SMMF", "SSBI", "SMMT", "SNBC", "SNHY", "SNDE", "SEMI", "SNSS", "STKL", "SPWR", "RUN", "SBCP", "SSH", "SUNW", "SMCI", "SPCB", "SCON", "SGC", "SUPN", "SPRT", "SGRY", "SCAI", "SRDX", "SBBX", "SIVB", "SIVBO", "SYKE", "SYMC", "SYNC", "SYNL", "SYNA", "SNCR", "SNDX", "SGYP", "SGYPU", "SGYPW", "ELOS", "SNPS", "SYNT", "SYMX", "SYUT", "SYPR", "SYRS", "SYRX", "TROW", "TTOO", "TRHC", "TCMD", "TAIT", "TTWO", "TLND", "TNDM", "TLF", "TNGO", "TANH", "TPIV", "TEDU", "TASR", "TATT", "TAYD", "TCPC", "AMTD", "TEAR", "TECD", "TCCO", "TTGT", "TGLS", "TGEN", "TNAV", "TTEC", "TLGT", "TENX", "GLBL", "TERP", "TRTL", "TRTLU", "TRTLW", "TVIA", "TBNK", "TSRO", "TESO", "TSLA", "TESS", "TSRA", "TTEK", "TTPH", "TCBI", "TCBIL", "TCBIP", "TCBIW", "TXN", "TXRH", "TFSL", "TGTX", "ABCO", "ANDE", "TBBK", "BONT", "CG", "CAKE", "CHEF", "TCFC", "DSGX", "DXYN", "ENSG", "XONE", "FINL", "FBMS", "FLIC", "GT", "HABT", "HCKT", "HAIN", "FITS", "CUBA", "INTG", "JYNT", "KEYW", "KHC", "OLD", "MDCO", "MIK", "MIDD", "NAVG", "SLIM", "STKS", "ORG", "PCLN", "PRSC", "BITE", "RMR", "SPNC", "TTD", "ULTI", "YORW", "NCTY", "TBPH", "TST", "TCRD", "THLD", "TICC", "TTS", "TIL", "TSBK", "TIPT", "TITN", "TTNP", "TIVO", "TMUS", "TMUSP", "TKAI", "TNXP", "TISA", "TOPS", "TORM          ", "TRCH", "TSEM", "TWER", "CLUB", "TOWN", "TPIC", "TCON", "TSCO", "TWMC", "TACT", "TRNS", "TBIO", "TGA", "TA", "TANNI", "TANNL", "TANNZ", "TZOO", "TRVN", "TCBK", "TRIL", "TRS", "TRMB", "TRIB", "TRIP", "TSC", "TBK", "TRNC", "TROV", "TROVU", "TROVW", "TRUE", "THST", "TRUP", "TRST", "TRMK", "TSRI", "TTMI", "TUBE", "TCX", "TUES", "TOUR", "HEAR", "TUTI", "TUTT", "FOX", "FOXA", "TWIN", "TRCB", "USCR", "PRTS", "USEG", "GROW", "UBNT", "UFPT", "ULTA", "UCTT", "RARE", "ULBI", "UTEK", "UMBF", "UMPQ", "UNAM", "UNIS", "UBSH", "UNB", "UNXL", "QURE", "UBCP", "UBOH", "UBSI", "UCBA", "UCBI", "UCFC", "UBNK", "UFCS", "UIHC", "UNFI", "UBFO", "USLM", "UTHR", "UG", "UNTY", "OLED", "UEIC", "UFPI", "ULH", "USAP", "UVSP", "UPLD", "URRE", "URBN", "ECOL", "USAT", "USATP", "USAK", "UTMD", "UTSI", "VALX", "VALU", "VNDA", "BBH", "GNRX", "PPH", "VWOB", "VNQI", "VGIT", "VCIT", "VIGI", "VYMI", "VCLT", "VGLT", "VMBS", "VNR", "VNRAP", "VNRBP", "VNRCP", "VONE", "VONG", "VONV", "VTWO", "VTWG", "VTWV", "VTHR", "VCSH", "VGSH", "VTIP", "BNDX", "VXUS", "VRNS", "VDSI", "VBLT", "VASC", "VBIV", "WOOF", "VECO", "DGLD", "DSLV", "UGLD", "USLV", "TVIZ", "TVIX", "ZIV", "XIV", "VIIZ", "VIIX", "APPY", "VRA", "VCYT", "VSTM", "VCEL", "VRNT", "VRSN", "VRSK", "VBTX", "VRML", "VSAR", "VTNR", "VRTX", "VRTB", "VIA", "VIAB", "VSAT", "VIAV", "VICL", "VICR", "CIZ", "CEZ", "CID", "CIL", "CFO", "CFA", "CSF", "CDC", "CDL", "CSB", "CSA", "VBND", "VUSE", "VIDI", "VDTH", "VRAY", "VKTX", "VKTXW", "VBFC", "VLGEA", "VIP", "VNOM", "VIRC", "VA", "VIRT", "VRTS", "VRTU", "VISN", "VTGN", "VTL", "VIVE", "VVUS", "VOD", "VLTC", "VOXX", "VYGR", "VSEC", "VTVT", "VUZI", "VWR", "WGBS", "WBA", "WAFD", "WAFDW", "WASH", "WFBI", "WSBF", "WVE", "WAYN", "WSTG", "WCFB", "WDFC", "FLAG", "WEB", "WBMD", "WCST", "WB", "WEBK", "WEN", "WERN", "WSBC", "WTBA", "WSTC", "WMAR", "WABC", "WBB", "WSTL", "WDC", "WNEB", "WLB", "WPRT", "WEYS", "WHLR", "WHLRD", "WHLRP", "WHLRW", "WHF", "WHFBL", "WFM", "WILN", "WHLM", "WVVI", "WVVIP", "WLDN", "WLFC", "WLTW", "WIN", "WINT", "WING", "WINA", "WINS", "WTFC", "WTFCM", "WTFCW", "AGND", "AGZD", "HYND", "HYZD", "CXSE", "EMCG", "EMCB", "DGRE", "DXGE", "WETF", "DXJS", "DXKW", "GULF", "CRDT", "DGRW", "DGRS", "DXPS", "UBND", "WIX", "WMIH", "WBKC", "WWD", "WKHS", "WRLD", "JMU", "WPCS", "WPPGY", "WMGI", "WMGIZ", "WSFS", "WSFSL", "WSCI", "WVFC", "WYNN", "XBIT", "XELB", "XCRA", "XNCR", "XBIO", "XBKS", "XENE", "XGTI", "XGTIW", "XLNX", "XOMA", "XPLR", "XTLB", "XNET", "YHOO", "YNDX", "YIN", "YRCW", "YECO", "YY", "ZFGN", "ZAGG", "ZAIS", "ZBRA", "ZLTQ", "Z", "ZG", "ZN", "ZNWAA", "ZION", "ZIONW", "ZIONZ", "ZIOP", "ZIXI", "ZGNX", "ZSAN", "ZUMZ", "ZYNE", "ZNGA"];

Tickers.prototype.ticker = function () {
  var length = Tickers.TICKERS.length;
  var index = Math.floor(Math.random() * length);
  return Tickers.TICKERS[index];
};

var tickers = new Tickers();
var lipsum = new LoremIpsum();

function getLipsum(num) {
  var phrase = lipsum.generate(num + 2);
  return phrase.substring(0, 1).toUpperCase() + phrase.substring(1);
}

function randomNumber(max, signed) {
  var val = Math.random() * max;
  if (signed) val *= Math.random() > 0.5 ? 1 : -1;
  return val;
}

function randomSignedNumber(max, negative) {
  var val = Math.random() * max;
  return val * (negative ? -1 : 1);
}

function randomArray(length, max) {
  var i = 0;
  var arr = [];
  var rnd = Math.random();
  var num, sign;

  if (rnd >= 0.2 && rnd < 0.7) {
    sign = true;
  } else if (rnd >= 0.7) {
    sign = false;
  }

  for (; i < length; i++) {
    if (typeof sign === "undefined") {
      num = randomNumber(max, true);
    } else {
      num = randomSignedNumber(max, !sign);
    }

    arr[i] = num;
  }

  return arr;
}

var scatterplot = {
  item: function item() {
    var ticker = tickers.ticker();
    return {
      totalReturn: randomNumber(20, true),
      standardDeviation: randomNumber(20, true),
      weight: randomNumber(100),
      ticker: ticker
    };
  },
  category: function category() {
    var arr = [];
    var num = Math.ceil(Math.random() * 5);
    var i = 0;

    for (; i < num; i++) {
      arr.push(scatterplot.item());
    }

    return {
      category: getLipsum(2),
      data: arr
    };
  },
  data: function data() {
    var dataset = [];
    var num = Math.ceil(Math.random() * 5) + 1;
    var i = 0;

    for (; i < num; i++) {
      dataset.push(scatterplot.category());
    }

    return {
      benchmark: {
        totalReturn: randomNumber(20, true),
        standardDeviation: randomNumber(20, true)
      },
      data: dataset
    };
  }
};
var barchart = {
  data: function data(howMany, maxValue) {
    var dataset = [];
    var num = Math.ceil(Math.random() * 5) + 1;
    var i = 0;
    howMany = howMany || 7;
    maxValue = maxValue || 100;

    for (; i < num; i++) {
      dataset.push(barchart.series(howMany, maxValue));
    }

    return dataset;
  },
  data2: function data2(howMany, maxValue) {
    var dataset = [];
    var num = Math.ceil(Math.random() * 5) + 1;
    var i = 0;
    howMany = howMany || 7;
    maxValue = maxValue || 100;

    for (; i < num; i++) {
      dataset.push({
        name: "Data " + (i + 1),
        values: randomArray(howMany, maxValue)
      });
    }

    return dataset;
  },
  series: function series(howMany, maxValue) {
    return {
      name: getLipsum(2),
      values: randomArray(howMany, maxValue)
    };
  },
  categories: function categories(prefix, num) {
    var arr = [];
    var i = 0;

    for (; i < num; i++) {
      arr[i] = prefix + " " + (i + 1);
    }

    return arr;
  },
  xlabels: function xlabels(num) {
    var i = 0;
    var arr = [];

    for (; i < num; i++) {
      if (Math.random() > 0.7) {
        arr[i] = getLipsum(1);
      } else {
        arr[i] = null;
      }
    }

    return arr;
  }
};

var getRandomDate = function getRandomDate(start, end) {
  return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
};

var generateDates = function generateDates(range, amtOfDates) {
  var dates = [];
  var dateRange;

  switch (range) {
    case "hours":
      dateRange = function dateRange() {
        return getRandomDate(new Date(2016, 0, 1), new Date(2016, 0, 2));
      };

      break;

    case "days":
      dateRange = function dateRange() {
        return getRandomDate(new Date(2016, 0, 1), new Date(2016, 0, 6));
      };

      break;

    case "weeks":
      dateRange = function dateRange() {
        return getRandomDate(new Date(2016, 0, 1), new Date(2016, 1, 28));
      };

      break;

    case "months":
      dateRange = function dateRange() {
        return getRandomDate(new Date(2016, 0, 1), new Date(2016, 11, 1));
      };

      break;

    case "quarters":
      dateRange = function dateRange() {
        return getRandomDate(new Date(2015, 0, 1), new Date(2016, 12, 31));
      };

      break;

    case "years":
      dateRange = function dateRange() {
        return getRandomDate(new Date(2010, 0, 1), new Date(2016, 11, 0));
      };

      break;

    default:
      console.error("range required to generate dates");
      break;
  }

  for (var i = 0; i < amtOfDates; i++) {
    dates.push(dateRange());
  }

  return dates;
};

function getIncrementalValue(increment) {
  var positive = Math.floor(Math.random() * 2 + 1) === 1 ? false : true;

  if (positive) {
    return Math.floor(Math.random() * increment);
  } else {
    return -Math.floor(Math.random() * increment);
  }
} //***** line chart *****/


var LineGenerator = function LineGenerator(dateRange) {
  this.leng = 50;
  this.dates = generateDates(dateRange, this.leng);
};

LineGenerator.prototype.generateDataset = function (opts) {
  return {
    y1: this.generateLineData(opts),
    y2: this.generateLineData(opts)
  };
};

LineGenerator.prototype.generateLineData = function (opts) {
  var groupName = Math.floor(Math.random() * 2 + 1) === 1 ? "y2" : "y1";
  var time = new Date();
  var name = time.getMilliseconds() + Math.floor(Math.random() * 999).toString();
  var segments = [];
  var currentValue = Math.floor(Math.random() + opts.minValue);

  for (var i = 0; i < opts.segments; i++) {
    var newValue;

    if (currentValue >= opts.maxValue || currentValue + opts.increment > opts.maxValue) {
      newValue = currentValue - opts.increment;
    } else {
      newValue = currentValue + getIncrementalValue(opts.increment);
    }

    segments.push({
      name: name,
      value: newValue,
      date: this.dates[i],
      groupName: groupName
    });
    currentValue = newValue;
  }

  return segments;
};
/**** end linechart */


module.exports = {
  ticker: tickers.ticker,
  lipsum: getLipsum,
  number: randomNumber,
  array: randomArray,
  scatterplot: scatterplot,
  barchart: barchart,
  getRandomDate: getRandomDate,
  generateDates: generateDates,
  linechart: LineGenerator,
  crmatrix: crmatrix
};

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(49);

__webpack_require__(65);

var names = ["Asia/Pacific Long-Short Equity", "Bear-Market Equity", "China Long-Short Equity", "Convertible Arbitrage", "Currency", "Debt Arbitage", "Distressed Securities", "Diversified Arbitage", "Emrg-Mkta Long-Short Equity", "Equity Market Neutral", "Europe Long-Short Equity", "Event Driven", "Global Long-Short Equity", "Global Macro", "Long-Short Debt", "Merger Arbitage", "Multistrategy", "Systematic Futures", "U.S. Long-Short Equity", "U.S. Sm-Cap Lg-Short Equity", "Volatility"];

function getDummyArray(n) {
  var i = 0;
  var arr = [];
  var sign;

  for (; i < n; i++) {
    sign = Math.random() < 0.5 ? -1 : 1;
    arr.push(Math.random() * sign);
  }

  return arr;
}

function getRandomName() {
  return names[Math.floor(names.length * Math.random())];
}

function getDummyRows(num) {
  var length = num || 3 + Math.floor(Math.random() * 47);
  var i = 0;
  var rows = [];
  var name;

  for (; i < length; i++) {
    name = getRandomName();
    rows.push(name);
  }

  return rows;
}

function getDummyMatrix(num) {
  var i;
  var j;
  var matrix = [];
  var length = num || 3 + Math.floor(Math.random() * 47);
  var sign, value; // for (i = 0; i < num; i++) {
  //     matrix[i] = [];
  // }

  for (i = 0; i < length; i++) {
    for (j = 0; j < length; j++) {
      if (!matrix[i]) matrix[i] = [];
      if (!matrix[j]) matrix[j] = [];
      sign = Math.random() < 0.5 ? -1 : 1;
      value = Math.random() * sign;

      if (j < i) {
        matrix[i][j] = value;
        matrix[j][i] = value;
      } else if (i === j) {
        matrix[i][j] = 1;
        break;
      }
    }
  }

  return matrix;
}

function grow(matrix) {
  var arr = getDummyArray(matrix.length);
  arr.forEach(function (val, i) {
    matrix[i].push(val);
  });
  arr.push(1);
  matrix.push(arr);
  return matrix;
}

function dataset(num) {
  var length = num || 3 + Math.floor(Math.random() * 47);
  var dummyRows = getDummyRows(length);
  var dummyMatrix = getDummyMatrix(length);
  return {
    rows: dummyRows,
    matrix: dummyMatrix
  };
}

module.exports = {
  matrix: getDummyMatrix,
  rows: getDummyRows,
  array: getDummyArray,
  dataset: dataset,
  grow: grow,
  name: getRandomName
};

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * morningstar-base-charts
 *
 * Copyright © 2016 . All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
var mbc_mds_constants = __webpack_require__(157).constants;

var mbc_mds_chart_color = mbc_mds_constants["chart-color"];
module.exports = {
  colors: [mbc_mds_chart_color["1"], mbc_mds_chart_color["2"], mbc_mds_chart_color["3"], mbc_mds_chart_color["4"], mbc_mds_chart_color["5"], mbc_mds_chart_color["6"], mbc_mds_chart_color["7"]],
  canvasDefaults: {
    axesSpacing: 5,
    margin: {
      top: 20,
      right: 20,
      bottom: 20,
      left: 20
    }
  }
};

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(40);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AxesManager = __webpack_require__(153);

var Base = __webpack_require__(136);

var Canvas = __webpack_require__(154);

var DataManager = __webpack_require__(158);

var ScalesManager = __webpack_require__(159);

var Utils = __webpack_require__(129);

var Classes = __webpack_require__(149);
/**
 * A foundation for all axed charts.
 * The renderng cycle is:
 * <em><br>0- setData() Data is initialized.
 * <br>1- beforeDraw() method is called. Event <i>beforeDraw</i> is triggered.
 * <br>2- draw() method is called.
 * <br>3- afterDraw() method called. Event <i>afterDraw</i> is triggered.</em>
 * <br><br><small>Methods setData() and draw() MUST be implemented</small>
 * @example
 * var BarChart = Chart.extend({
 *  ...
 * })
 * @param {Object} options
 * @class
 * @extends Base
 */


var Chart = Base.extend(
/**
 * A foundation for all axed charts.
 *  @lends Chart.prototype
 **/
{
  /** @type {String} */
  UID: null,

  /** @type {AxisManager} */
  axes: null,

  /** @type {Canvas} */
  canvas: null,

  /** @type {DataManager} */
  data: null,

  /** @type {Array} */
  colors: Utils.colors.combined,

  /** @type {D3.dispatch} */
  dispatch: null,

  /** @type {ScaleManager} */
  scales: null,

  /** @type {Object} */
  margins: {
    top: 20,
    right: 40,
    bottom: 30,
    left: 40
  },

  /** @type {String} */
  canvasTemplate: null,

  /** @type {Number} */
  yAxesLabelWidth: 0,

  /** @type {String} */
  legendPopoverParentElement: 'body',
  // pass string selector id including # (e.g. '#line-chart-container') or class including . (e.g. '.mbc-line-chart') of element to append popover

  /**
   * Initializes the chart.
   */
  initializer: function initializer() {
    this.set("UID", "mbc" + Utils.string.UID());
    this.set("axes", new AxesManager());
    this.set("data", new DataManager());
    this.set("dispatch", d3.dispatch("hover", "click", "afterDraw", "beforeDraw", "mouseout"));
    this.set("scales", new ScalesManager());
    d3.rebind(this, this.get("dispatch"), "on");
  },

  /**
   * Returns the function D3 calls to set the data.
   * @example
   * container.datum(dataset).call(chart.init());
   *
   * @returns {Function}
   */
  init: function init() {
    return this._createChart.bind(this);
  },

  /**
   * Adds a new Canvas object and calls the _prepare function for each selection
   * @param {D3.Selection} name Selection where the charts are going to be created.
   * @private
   */
  _createChart: function _createChart(selection) {
    var _selection$classed;

    this.set("selection", selection);
    selection.classed((_selection$classed = {}, _defineProperty(_selection$classed, this.get("id") || "", true), _defineProperty(_selection$classed, this.get("UID"), true), _selection$classed));

    this._createCanvas();

    selection.each(this._prepare.bind(this));
  },

  /**
   * Create and set a new canvas instance.
   */
  _createCanvas: function _createCanvas() {
    var selection = this.get("selection"); // beforeCanvas method is called if exists.

    Utils.fn.call(this, this.beforeCanvas, selection);
    this.set("canvas", new Canvas({
      selection: selection,
      margin: this.get("margins"),
      template: this.get("canvasTemplate"),
      yAxesLabelWidth: this.get("yAxesLabelWidth"),
      UID: this.get("UID")
    }));
  },

  /**
   * Calls the setData or/and setup function if they exist and calls the rendering cycle if the data is valid.
   * @private
   */
  _prepare: function _prepare(data) {
    var invalidData = false;
    invalidData = Utils.fn.call(this, this.setup, data);
    /* FIXME: remove setData call next major version */

    invalidData = invalidData || Utils.fn.call(this, this.setData, data);
    if (!invalidData) this.update();
  },

  /**
   * Executes the rendering cycle in this order
   * <li> beforeDraw
   * <li> draw
   * <li> afterDraw
   */
  update: function update(options) {
    this.get("dispatch").beforeDraw();
    var updateCanvas = Utils.fn.call(this, this.beforeDraw, options);
    if (typeof updateCanvas === "undefined" || updateCanvas) this.get("canvas").update();
    this.draw(options);
    Utils.fn.call(this, this.afterDraw, options);
    this.get("dispatch").afterDraw();
  },

  /**
   * Returns the index *n* color from the *colors* attribute array
   * @param {Number} index Index of color to return
   */
  color: function color(index) {
    var colors = this.get("colors");
    return colors[index % colors.length];
  },

  /**
   * Returns a closure function with a formatter within.
   * @param {Function|String} format If it is a string uses d3.format.
   */
  tickFormat: function tickFormat(format) {
    return function (d, i) {
      if (!format) {
        return d;
      }

      return typeof format === "function" ? format(d, i) : d3.format(format)(d);
    };
  },

  /**
   * @abstract
   * @deprecated Use setup method instead.
   * Prepare the data for the chart and all the initial values prior to start rendering. Legacy.
   */
  setData: function setData() {},

  /**
   * @abstract
   * Prepare the data for the chart and all the initial values prior to start rendering.
   */
  setup: function setup() {},

  /**
   * @abstract
   * This method is called before creating the canvas instance, is useful to change the template before.
   */
  beforeCanvas: function beforeCanvas() {},

  /**
   * @abstract
   * This method is called before drawing the chart. Useful to prepare data when the SVG element is already inserted into the dom.
   */
  beforeDraw: function beforeDraw() {},

  /**
   * @abstract
   * Used to draw the chart into the SVG element.
   */
  draw: function draw() {
    console.error(new Error("draw method is not defined"));
  },

  /**
   * @abstract
   * Called after the chart is rendered. Useful to make post-render modifications.
   */
  afterDraw: function afterDraw() {},

  /**
   * Returns an id based class.
   * @param {String} suffix Suffix to add to the id.
   * @return {String} The class name (id + suffix).
   */
  getId: function getId(suffix) {
    return this.get("id") + "-" + suffix;
  },

  /**
   * @adjustYLabels
   * Visual adjustments after the chart has been rendered
   * appendYAbbreviation and adjustYAxisLabel
   */
  adjustYLabels: function adjustYLabels() {
    var axes = this.get("canvas").get("axesGroup");
    axes.selectAll(".x-alternative-first, .x-alternative-last").remove();
    axes.selectAll(".".concat(Classes.AXIS, "-left .tick text, .").concat(Classes.AXIS, "-right .tick text")).attrs({
      x: 0,
      y: 12
    });
    var y1Ticks = axes.selectAll(".".concat(Classes.AXIS, "-y1 .tick"));
    y1Ticks.first().classed("dark", true).select("text").attr("y", -10);
    y1Ticks.last().classed("dark", true);
    var y2Ticks = axes.selectAll(".".concat(Classes.AXIS, "-y2 .tick"));
    y2Ticks.first().classed("dark", true).select("text").attr("y", -10);
    y2Ticks.last().classed("dark", true);
    var y1TicksAlign = this.get("y1TicksAlign");
    var y1AxisOrient = this.get("y1AxisOrient");
    var y1Texts = axes.selectAll(".".concat(Classes.AXIS, "-y1 text"));

    if (y1TicksAlign === "right" && y1AxisOrient === "right") {
      y1Texts.attr("x", this.get("yTickSize")).style("text-anchor", "end");
    }

    if (y1TicksAlign === "left" && y1AxisOrient === "left") {
      y1Texts.attr("x", this.get("yTickSize") * -1).style("text-anchor", "start");
    }

    if (this.get("y2TicksAlign") === "right" && this.get("y2AxisOrient") === "right") {
      axes.selectAll(".".concat(Classes.AXIS, "-y2 text")).attr("x", this.get("yTickSize")).style("text-anchor", "end");
    }

    this.appendYAbbreviation(axes);
    this.adjustYAxisLabel("y1");

    if (this.get("y2")) {
      this.adjustYAxisLabel("y2");
    }
  },

  /**
   * Appends Y axes abbreviations under the up most tick.
   * Checks for 'y1Abbreviation' and 'y2Abbreviation.
   */
  appendYAbbreviation: function appendYAbbreviation(axes) {
    var appendAbbrev = function appendAbbrev(tick, abbrev, align) {
      var lastText = tick.select("text");
      tick.append("text").attrs({
        "text-anchor": align === "right" ? "end" : "start",
        x: lastText.attr("x"),
        y: lastText.attr("y") * 2 + 4,
        dy: lastText.attr("dy")
      }).classed("mbc-tick-abbreviation", true).text(abbrev);
    };

    var lastTick, textAlign;
    var y1Abbrev = this.get("y1Abbreviation"),
        y2Abbrev = this.get("y2Abbreviation");

    if (y1Abbrev) {
      lastTick = axes.selectAll(".".concat(Classes.AXIS, "-y1 .tick")).last();
      textAlign = this.get("y1TicksAlign");
      appendAbbrev(lastTick, y1Abbrev, textAlign);
    }

    if (this.get("y2") && y2Abbrev) {
      lastTick = axes.selectAll(".".concat(Classes.AXIS, "-y2 .tick")).last();
      textAlign = this.get("y2TicksAlign");
      appendAbbrev(lastTick, y2Abbrev, textAlign);
    }
  },

  /**
   * @adjustYAxisLabel
   * dynamic hide Y labels to avoid overlap
   * @param {String} yAxisName: "y1" or "y2"
   */
  adjustYAxisLabel: function adjustYAxisLabel(yAxisName) {
    var axes = this.get("canvas").get("axesGroup"),
        tickValues = this.get("axes").axis(yAxisName).tickValues(),
        axesTicks = axes.selectAll(".".concat(Classes.AXIS, "-").concat(yAxisName, " .tick")),
        textSpacing = 23; // the height of tick text(18 + 0.32em)

    var lastPosition = 0,
        beforeLastPosition = 0,
        beforeLastShowedTickIndex = 0,
        lastShowedTickIndex = 0,
        showLastShowedTick = true,
        showBeforeLastShowedTick = true;
    axesTicks.style({
      opacity: function opacity(d, i) {
        var opacity = 0;
        var tickPosition = d3.transform(this.getAttribute("transform")).translate[1];
        var textTotalDy = parseFloat(this.lastChild.attributes.dy.value) * (this.childNodes.length - 1) * 14;
        var textDistance = +this.lastChild.attributes.y.value + textTotalDy;
        var currentPosition = tickPosition + textDistance;
        var distance = Math.abs(currentPosition - lastPosition);

        if (distance > textSpacing) {
          opacity = 1;
          beforeLastShowedTickIndex = lastShowedTickIndex;
          lastShowedTickIndex = i;
          beforeLastPosition = lastPosition;
          lastPosition = currentPosition;
        }

        if (i === tickValues.length - 1 && opacity === 0) {
          opacity = 1;
          showLastShowedTick = false;

          if (Math.abs(currentPosition - beforeLastPosition) < textSpacing) {
            showBeforeLastShowedTick = false;
          }
        }

        return opacity;
      }
    });

    if (!showLastShowedTick && showLastShowedTick !== 0) {
      d3.select(axesTicks[0][lastShowedTickIndex]).style({
        opacity: 0
      });
    }

    if (!showBeforeLastShowedTick && beforeLastShowedTickIndex !== 0) {
      d3.select(axesTicks[0][beforeLastShowedTickIndex]).style({
        opacity: 0
      });
    }
  },

  /**
   * Appends a Y axis label.
   * @param {Object} layer: "y1" or "y2"
   * @param {String} axisName: "y1" or "y2"
   * @param {String} text: y1AxisLabel or y2AxisLabel
   */
  appendYLabel: function appendYLabel(layer, axisName, text, adjustCanvasHeight) {
    var yTickSize = this.get("yTickSize");
    var canvas = this.get("canvas");
    var axis = this.get("axes").axis(axisName);
    var isLeft = axis.orient() === "left";
    var axisSelector = "".concat(Classes.AXIS, "-").concat(axisName);
    var anchor = isLeft ? "start" : "end";
    var rotation = isLeft ? 270 : 90;
    var axisLayer, translate, x, y, yLabel, svgText;
    var yAxesLabelPadding = this.get("yAxesLabelPadding");
    adjustCanvasHeight = adjustCanvasHeight === undefined ? 0 : adjustCanvasHeight; // Calculating

    axisLayer = canvas.layer(axisSelector, "axes", true);
    translate = d3.transform(axisLayer.attr("transform")).translate;
    x = isLeft ? translate[0] - yAxesLabelPadding - yTickSize : translate[0] + yTickSize + yAxesLabelPadding;
    y = canvas.height() - adjustCanvasHeight;
    yLabel = layer.append("g").attr("".concat(axisSelector, "-label"), "axes").attr("transform", "translate(".concat(x, ", ").concat(y, ")"));
    svgText = yLabel.append("text").text(text).classed("".concat(axisSelector, "-label-text"), "true").classed("mbc-y-axis-text", "true").attrs({
      "text-anchor": anchor,
      transform: "rotate(".concat(rotation, ")")
    }); // dynamic abbreviate yAxisLabel if it is higher than container

    var labelText = svgText[0][0];
    var textHeight = Math.abs(labelText.clientWidth);

    if (textHeight > y) {
      var maxNum = Math.floor(y / (textHeight / text.length));
      labelText.innerHTML = text.substr(0, maxNum - 2) + "...";
    }
  }
});
module.exports = Chart;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  // d3 overrides
  //----------------------------------
  d3.selection.prototype.first = function () {
    if (!this[0]) {
      return d3.select();
    }

    return d3.select(this[0][0]);
  };

  d3.selection.prototype.last = function () {
    if (!this[0]) {
      return d3.select();
    }

    var last = this.size() - 1;
    return d3.select(this[0][last]);
  };

  d3.selection.prototype.attrs = function (obj) {
    for (var attr in obj) {
      this.attr(attr, obj[attr]);
    }

    return this;
  }; //---------------oOo-----------------

};

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  // Makes version of MBC available on window for debugging
  // VERSION is dynamically replaced as prebuild step
  window.mbc = {
    version: "2.33.4-0"
  };
};

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DateAxis = __webpack_require__(177);

module.exports = {
  DateAxis: DateAxis
};

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(101);

__webpack_require__(49);

__webpack_require__(65);

__webpack_require__(40);

__webpack_require__(114);

__webpack_require__(85);

var Core = __webpack_require__(152);

var Utils = __webpack_require__(129);

var Base = __webpack_require__(136);

var DateAxis = Base.extend({
  /*axis data*/
  domain: [],
  range: [0, 0],
  subLabels: [],

  /*axis style*/
  orient: 'bottom',
  labelSpacing: 10,
  font: '14px helvetica neue',
  rangeBandsPadding: 0.00,
  rangeBandsOuterPadding: 0.00,

  /*label format*/
  labelFormat: '%b',
  subLabelFormat: '%Y',
  subLabelDx: '-0.75em',
  tickFormat: null,
  timeLevel: 'monthly',
  //======================= initialize ==========================
  initializer: function initializer() {
    this._initData();

    this._initScale();

    this._initAxis();
  },
  _initData: function _initData() {
    var opDomain = this.get('domain');

    var labelInterval = this._calcLabelInterval();

    var subLabels = this._calcSubLabels(opDomain, labelInterval);

    this.set('labelInterval', labelInterval);
    this.set('subLabels', subLabels); //temporary handle way, will set a map to contain yearly, quarterly, monthly

    var timeLevel = this.get('timeLevel').toLowerCase();

    switch (timeLevel) {
      case 'quarterly':
        this.set('tickFormat', this.quarterlyTickFormat);
        this.set('subLabelDx', '-0.5em');
        break;

      case 'yearly':
        this.set('tickFormat', d3.time.format('%Y'));
        this.set('subLabels', []);
        break;

      default:
        this.set('tickFormat', d3.time.format(this.get('labelFormat')));
        break;
    }
  },
  _initScale: function _initScale() {
    var domain = this.get('domain'),
        range = this.get('range');
    var scale = d3.scale.ordinal().domain(domain).rangeBands(range, this.get('rangeBandsPadding'), this.get('rangeBandsOuterPadding'));
    this.set('scale', scale);
  },
  _initAxis: function _initAxis() {
    var scale = this.getScale(),
        orient = this.get('orient'),
        formatFun = this.get('tickFormat'),
        labelInterval = this.get('labelInterval'),
        getDate = this.getDate;
    var axis = d3.svg.axis().scale(scale).orient(orient).tickFormat(function (d, i) {
      if (i % labelInterval !== 0) {
        return '';
      }

      if (typeof formatFun === 'function') {
        return formatFun(getDate(d));
      }

      return d;
    });
    this.set('axis', axis);
  },
  _calcLabelInterval: function _calcLabelInterval() {
    var opDomain = this.get('domain'),
        range = this.get('range'),
        axisWidth = range[1] - range[0],
        spacing = this.get('labelSpacing'),
        labelFormat = d3.time.format(this.get('labelFormat')),
        getDate = this.getDate,
        maxTextWidth,
        maxLabelCount,
        labelInterval;
    maxTextWidth = this.calcMaxTextWidth(opDomain.map(function (item) {
      return labelFormat(getDate(item));
    })); //maxText * n + spacing * (n-1) < width;

    maxLabelCount = Math.floor((axisWidth + spacing) / (maxTextWidth + spacing));
    labelInterval = Math.ceil(opDomain.length / maxLabelCount);
    return labelInterval;
  },
  _calcSubLabels: function _calcSubLabels(domain, labelInterval) {
    if (!Array.isArray(domain)) {
      return [];
    }

    var subLabels = [];
    var timeFormat = d3.time.format;
    var subLabelFormat = timeFormat(this.get('subLabelFormat'));
    var getDate = this.getDate;
    domain.forEach(function (item, index) {
      var date = getDate(item);
      var label = subLabelFormat(date);

      if (index % labelInterval === 0 && subLabels.indexOf(label) === -1) {
        subLabels.push(label);
      } else {
        subLabels.push(null);
      }
    });
    return subLabels;
  },
  //======================== public methods ======================
  draw: function draw(selection) {
    var axis = this.getAxis();
    selection.call(axis);
  },
  drawSubLabels: function drawSubLabels(canvas) {
    var xScale = this.get("scale");
    var xAxisOrient = this.get("orient");
    var subLabels = this.get("subLabels");
    var xlayer = canvas.layer("mbc-axes-xlabels", "axes");
    var xTexts;
    xTexts = xlayer.selectAll(".mbc-x-label").data(xScale.domain());
    xTexts.enter().append("g").classed("mbc-x-label", true).attr("transform", function (d) {
      var x = xScale(d) + xScale.rangeBand() / 2;
      var y = xAxisOrient === "bottom" ? canvas.height() + 35 : -25;
      return "translate(".concat(x, ", ").concat(y, ")");
    }).append("text").text(function (d, i) {
      var label = "";

      if (i < subLabels.length) {
        label = subLabels[i] || "";
      }

      return label;
    }).attrs({
      "text-anchor": "start",
      "dx": this.get("subLabelDx")
    });
  },
  getScale: function getScale() {
    return this.get('scale');
  },
  getAxis: function getAxis() {
    return this.get('axis');
  },
  //=================== util methods ============================
  isInvalidDate: function isInvalidDate(date) {
    if (date instanceof Date && date.toString() !== 'Invalid Date') {
      return false;
    }

    return true;
  },
  checkLabelsWidth: function checkLabelsWidth(labelList, axisWidth, spacing, font) {
    var totalSpacing = spacing * (labelList.length - 1);
    var totalWidth = this.getTextWidth({
      font: font,
      text: labelList.join('')
    }); //axis can show all labels well.

    if (axisWidth > totalWidth + totalSpacing) {
      return true;
    }

    return false;
  },
  getTextWidth: function getTextWidth(option) {
    var canvas = this.getTextWidth.canvas || (this.getTextWidth.canvas = document.createElement('canvas'));
    var context = canvas.getContext('2d');
    context.font = option.font;
    var dimension = context.measureText(option.text);
    return dimension.width;
  },
  calcMaxTextWidth: function calcMaxTextWidth(texts) {
    var _this = this;

    var font = this.get('font');
    var maxTextWidth = d3.max(texts.map(function (text) {
      return _this.getTextWidth({
        font: font,
        text: text
      });
    }));
    return maxTextWidth;
  },
  getDate: function getDate(maskDate) {
    return new Date(Utils.string.unmask(maskDate));
  },
  quarterlyTickFormat: function quarterlyTickFormat(date) {
    var month = +d3.time.format('%m')(date);
    var quarterly = [3, 6, 9, 12];

    if (quarterly.indexOf(month) === -1) {
      return;
    }

    return "Q" + month / 3;
  },
  //========================= getter & setter ============================
  get: function get(key) {
    return this.__attributes[key];
  },
  set: function set(key, value) {
    this.__attributes[key] = value;
  }
});
module.exports = DateAxis;

/***/ })
/******/ ]);
});